import { ImagePaths } from "./ImagePaths";
import "./Services/CacheProviderService"
import { localGetItem } from "./Services/CacheProviderService";

export class Constants {
    static SaveSuccess = "Record saved successfully !";
    static CancelRequest = "Canceled successfully !";
    static Deleted = "Deleted successfully !";
    static WarningToast = "Warning";
    static Failed = "Failed to load";
}
export const StockAdjustment_Reason = [
    { id: 1, name: "Breakage" },
    { id: 2, name: "Loss" },
    { id: 3, name: "Expired" },
    { id: 4, name: "Miscellaneous" }
]

export const Demo_Layout_Default_JSON = [
    { id: 1, field_name: 'mobile_no', label: 'Mobile no', is_active: true, is_default: true },
    { id: 2, field_name: 'first_name', label: 'First Name', is_active: true, is_default: true },
    { id: 3, field_name: 'dob', label: 'Date of Birth', is_active: true, is_default: true },
    { id: 4, field_name: 'gender', label: 'Gender', is_active: true, is_default: true },
    { id: 5, field_name: 'age', label: 'Age', is_active: true, is_default: false },
    { id: 6, field_name: 'title', label: 'Title', is_active: true, is_default: false },
    { id: 7, field_name: 'middle_name', label: 'Middle Name', is_active: true, is_default: false },
    { id: 8, field_name: 'surname', label: 'Surname', is_active: true, is_default: false },
    { id: 9, field_name: 'address_1', label: 'Address 01', is_active: true, is_default: false },
    { id: 10, field_name: 'address_2', label: 'Address 02', is_active: true, is_default: false },
    { id: 11, field_name: 'city', label: 'City', is_active: true, is_default: false },
    { id: 12, field_name: 'state', label: 'State', is_active: true, is_default: false },
    { id: 13, field_name: 'country', label: 'Country', is_active: true, is_default: false },
    { id: 14, field_name: 'pin_code', label: 'Pin Code', is_active: true, is_default: false },
    { id: 15, field_name: 'employer_id', label: 'Corporate Name', is_active: true, is_default: false },
    { id: 16, field_name: 'employee_id', label: 'Employee ID No', is_active: true, is_default: false },
    { id: 17, field_name: 'email_id', label: 'Email ID', is_active: true, is_default: false },
    { id: 18, field_name: 'marital_status', label: 'Marital Status', is_active: true, is_default: false },
    { id: 19, field_name: 'father_husband_name', label: 'Father/Spouse Name', is_active: true, is_default: false },
    { id: 20, field_name: 'father_husband_age', label: 'Father/Spouse Age', is_active: true, is_default: false },
    { id: 21, field_name: 'mother_name', label: "Mother's Name", is_active: true, is_default: false },
    { id: 22, field_name: 'mother_age', label: "Mother's Age", is_active: true, is_default: false },
    { id: 23, field_name: 'occupation', label: 'Occupation', is_active: true, is_default: false },
    { id: 24, field_name: 'emergency_contact_person', label: 'Emergency Contact Person', is_active: true, is_default: false },
    { id: 25, field_name: 'emergency_contact_mobile', label: 'Emergency Mobile No', is_active: true, is_default: false },
    { id: 26, field_name: 'relationship', label: 'Relationship', is_active: true, is_default: false },
    { id: 27, field_name: 'insurance_company_name', label: 'Insurance Company Name', is_active: true, is_default: false },
    { id: 28, field_name: 'policy_number', label: 'Insurance No', is_active: true, is_default: false },
    { id: 29, field_name: 'guardian', label: 'Guardian', is_active: true, is_default: false },
    { id: 30, field_name: 'old_referral_no', label: 'Old / Referral No', is_active: true, is_default: false },
    { id: 31, field_name: 'blood_group', label: 'Blood Group', is_active: true, is_default: false },
    { id: 32, field_name: 'rchid', label: 'RCH ID', is_active: false, is_default: false },
    ... (localGetItem('has_abha_service') === 'true' ? [{ id: 33, field_name: 'district', label: 'District', is_active: true, is_default: false }] : []),
]

export const Dis_Summary_Layout_JSON = [
    { id: 1, field_name: "admission_diagnosis", label: 'Admission Diagnosis', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    // { id: 2, field_name: "provisional_diagnosis", label: 'Provisional Diagnosis', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 2, field_name: "symptoms_key_findings", label: 'Symptoms/Key Findings', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 3, field_name: "examination", label: 'Examination', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 4, field_name: "investigation_and_test_report", label: 'Investigation and Test Report', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 5, field_name: "summary_of_Key_finding_during_hospitalization", label: 'Summary of Key Finding During Hospitalization', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 6, field_name: "procedure_treatment_given_during_hospitalization", label: 'Procedure/Treatment Given During Hospitalization', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 7, field_name: "operations_surgery_notes", label: 'Operations/Surgery Notes', is_active: true, is_mantatory: false, is_default_mantatory: false },
    { id: 8, field_name: "name_anaesthetist_and_type_of_anaesthesia", label: 'Name Anaesthetist and Type of Anaesthesia', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 9, field_name: "discharge_diagnosis", label: 'Discharge Diagnosis', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 10, field_name: "condition_on_discharge", label: 'Condition on Discharge', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 11, field_name: "medication", label: 'Medication', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 12, field_name: "discharge_instruction", label: 'Discharge Instruction', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 13, field_name: "in_hospital_medication", label: 'In Hospital Medication', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 14, field_name: "vitals", label: 'Vitals', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 15, field_name: "radiology_report", label: 'Radiology Report', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 16, field_name: "investigation_report", label: 'Investigation Report', is_active: false, is_mantatory: false, is_default_mantatory: false, is_new: false },
]

export const Surgey_Notes_Layout_JSON = [
    { id: 1, field_name: 'reason_for_hospital_stay', label: 'Reason for Hospital Stay', is_active: true, is_mantatory: true, is_default_mantatory: true, is_new: false },
    { id: 2, field_name: 'patient_admits_to_having', label: 'Patient Admits to Having', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 3, field_name: 'patient_denies_having', label: 'Patient Denies Having', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 4, field_name: 'preop_diagnosis', label: 'Preop Diagnosis', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 5, field_name: 'postop_diagnosis', label: 'Postop Diagnosis', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 6, field_name: 'procedure', label: 'Procedure', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 7, field_name: 'surgeon', label: 'Surgeon', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 8, field_name: 'staff_nurse', label: 'Staff Nurse', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 9, field_name: 'assistant', label: 'Assistant(s)', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 10, field_name: 'type_of_anaesthesia', label: 'Type of Anaesthesia', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 11, field_name: 'fluids_given', label: 'Fluids Given', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 12, field_name: 'urine_output', label: 'Urine Output', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 13, field_name: 'estimated_blood_loss', label: 'Estimated Blood Loss(EBL)', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 14, field_name: 'specimen', label: 'Specimen', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 15, field_name: 'drains', label: 'Drains', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 16, field_name: 'plan', label: 'Plan', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
    { id: 17, field_name: 'date_time_name_of_doctor_signature', label: 'Date/Time, Name of Doctor, Signature', is_active: true, is_mantatory: false, is_default_mantatory: false, is_new: false },
]
export const FloorCountDropdown = 20;

export const RoomHoursList = [
    { id: 24, value: '24hr', label: 'Upto 24 Hrs' },
    { id: 1, value: '1hr', label: 'Upto 1 Hrs' },
    { id: 2, value: '2hr', label: 'Upto 2 Hrs' },
    { id: 3, value: '3hr', label: 'Upto 3 Hrs' },
    { id: 4, value: '4hr', label: 'Upto 4 Hrs' },
    { id: 5, value: '5hr', label: 'Upto 5 Hrs' },
    { id: 6, value: '6hr', label: 'Upto 6 Hrs' },
    { id: 7, value: '7hr', label: 'Upto 7 Hrs' },
    { id: 8, value: '8hr', label: 'Upto 8 Hrs' },
    { id: 9, value: '9hr', label: 'Upto 9 Hrs' },
    { id: 10, value: '10hr', label: 'Upto 10 Hrs' },
    { id: 11, value: '11hr', label: 'Upto 11 Hrs' },
    { id: 12, value: '12hr', label: 'Upto 12 Hrs' },
    { id: 13, value: '13hr', label: 'Upto 13 Hrs' },
    { id: 14, value: '14hr', label: 'Upto 14 Hrs' },
    { id: 15, value: '15hr', label: 'Upto 15 Hrs' },
    { id: 16, value: '16hr', label: 'Upto 16 Hrs' },
    { id: 17, value: '17hr', label: 'Upto 17 Hrs' },
    { id: 18, value: '18hr', label: 'Upto 18 Hrs' },
    { id: 19, value: '19hr', label: 'Upto 19 Hrs' },
    { id: 20, value: '20hr', label: 'Upto 20 Hrs' },
    { id: 21, value: '21hr', label: 'Upto 21 Hrs' },
    { id: 22, value: '22hr', label: 'Upto 22 Hrs' },
    { id: 23, value: '23hr', label: 'Upto 23 Hrs' },
]

export const RoomDayHourList = [
    { id: 24, value: '24hr', label: 'Upto 24 Hrs' },
    { id: 12, value: '12hr', label: 'Upto 12 Hrs' },
]

export const DurationsList = [
    { id: 1, value: 'days', label: 'Day(s)' },
    { id: 2, value: 'week', label: 'Week(s)' },
    { id: 3, value: 'month', label: 'Month(s)' },
]
export const FullDurationsList = [
    { id: 1, value: 'days', label: 'Day(s)' },
    { id: 2, value: 'week', label: 'Week(s)' },
    { id: 3, value: 'month', label: 'Month(s)' },
    // { id: 4, value: 'year', label: 'Year(s)' },
]

export const DurationCounts = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
export const MaenList = [
    // { value: 0, label: '0' },
    { value: 0.5, label: '0.5' },
    { value: 1, label: '1' },
    { value: 1.5, label: '1.5' },
    { value: 2, label: '2' },
    { value: 2.5, label: '2.5' },
    { value: 3, label: '3' },
    { value: 3.5, label: '3.5' },
]


export const IP_routeList = [
    { value: 'Intravenous' },
    { value: 'Intramuscular' },
    { value: 'Subcutaneous' },
    { value: 'Rectal' },
    { value: 'Vaginal' },
    { value: 'Inhaler' },
    { value: 'Inhaled' },
    { value: 'Eye' },
    { value: 'Oral' },
    { value: 'Sublingual and buccal' },
    { value: 'Otic' },
    { value: 'Nasal' },
    { value: 'Cutaneous' },
    { value: 'Transdermal' },
    { value: 'Dressing' },
    { value: 'Others' },
]

export const IP_unit = [
    { value: "ml", label: 'ml' },
    { value: "mg", label: 'mg' },
]

export const multi_option = [
    { value: "History", label: "History" },
]

export const Taper_Med_Dosages = [
    { value: 'STEROID TABLETS', label: "Steroid Tablets" },
    { value: 'DROP', label: "Drops" },
];

export const Taper_Med_Frequency = [
    { label: "1 time a day", value: 1 },
    { label: "2 times a day", value: 2 },
    { label: "3 times a day", value: 3 },
    { label: "4 times a day", value: 4 },
    { label: "5 times a day", value: 5 },
    { label: "6 times a day", value: 6 },
    { label: "10 times a day", value: 10 },
    { label: "12 times a day", value: 12 }
];
export const PainLevel = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const Speciality_Item = [
    { id: 1, value: 'Orthopedics', label: 'Orthopedics' },
    { id: 2, value: 'Internal Medicine', label: 'Internal Medicine' },
    { id: 3, value: 'Obstetrics and Gynecology', label: 'Obstetrics and Gynecology' },
    { id: 4, value: 'Dermatology', label: 'Dermatology' },
    { id: 5, value: 'Pediatrics', label: 'Pediatrics' },
    { id: 6, value: 'Radiology', label: 'Radiology' },
    { id: 7, value: 'General Surgery', label: 'General Surgery' },
    { id: 8, value: 'Ophthalmology', label: 'Ophthalmology' },
    { id: 9, value: 'Family Medicine', label: 'Family Medicine' },
    { id: 10, value: 'Chest Medicine', label: 'Chest Medicine' },
    { id: 11, value: 'Anesthesia', label: 'Anesthesia' },
    { id: 12, value: 'Pathology', label: 'Pathology' },
    { id: 13, value: 'ENT', label: 'ENT' },
]
export let isBranch = JSON.parse(localStorage.getItem("loggedInUserInfo"))?.branch_to_branch_stock_transfer ? true : false
export let MODULE_LIST_DATA = [
    {
        title: "front_office",
        module_type: "front_office",
        data: [{
            image: ImagePaths.LabHomeOff.default,
            title: "Home",
            viewAccess: true,
            editAccess: false,
            main_tabs: [
                { viewAccess: true, editAccess: false, title: "OP Appointments" },
                { viewAccess: false, editAccess: false, title: "Demographics" },
                {
                    viewAccess: false, editAccess: false, title: "Billing",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Create Bill" },
                        { viewAccess: false, editAccess: false, title: "Saved Bill" },
                        { viewAccess: false, editAccess: false, title: "Bills" },
                        { viewAccess: false, editAccess: false, title: "Receipts" }
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Nurse Notes",
                    sub_tabs: [
                        {
                            viewAccess: false,
                            editAccess: false,
                            title: "Vitals"
                        },
                        {
                            viewAccess: false,
                            editAccess: false,
                            title: "Treatment Plan"
                        },
                        {
                            viewAccess: false,
                            editAccess: false,
                            title: "Notes"
                        }
                    ]
                },
                { viewAccess: false, editAccess: false, title: "Doctor Visit Reports" },
                { viewAccess: false, editAccess: false, title: "Test Reports" },
                { viewAccess: false, editAccess: false, title: "Print Order Reports" },
                {
                    viewAccess: false, editAccess: false, title: "Corporate",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Claim Details" },
                    ]
                },
                { viewAccess: false, editAccess: false, title: "Patient Document" },
                { viewAccess: false, editAccess: false, title: "Form 4/4A" },
                { viewAccess: false, editAccess: false, title: "Discharge Summary Reports" },
                { viewAccess: false, editAccess: false, title: "Surgery Reports" },
            ]
        }, {
            image: ImagePaths.IpHomeOff.default,
            title: "In Patients",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Patient Details" },
                {
                    viewAccess: false, editAccess: false, title: "Service Billing",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: 'Create Bill' },
                        { viewAccess: false, editAccess: false, title: "Saved Bill" },
                        { viewAccess: false, editAccess: false, title: "Bills" },
                        { viewAccess: false, editAccess: false, title: "Receipts" }
                    ]
                },
                { viewAccess: false, editAccess: false, title: "Room Change" },
                { viewAccess: false, editAccess: false, title: "Receive Payment" },
                { viewAccess: false, editAccess: false, title: "Intial Assessment" },
                {
                    viewAccess: false, editAccess: false, title: "Clinical Notes",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Vitals" },
                        { viewAccess: false, editAccess: false, title: "Nurse Assessments" },
                        { viewAccess: false, editAccess: false, title: "Doctor Notes" },
                        { viewAccess: false, editAccess: false, title: "Nurse Notes" },
                        { viewAccess: false, editAccess: false, title: "IV / IM Track" },
                        { viewAccess: false, editAccess: false, title: "Drug Chart" },
                        { viewAccess: false, editAccess: false, title: "Pain Chart" },
                        { viewAccess: false, editAccess: false, title: "Nutrition Chart" },
                        { viewAccess: false, editAccess: false, title: "Input/OutPut Chart" },
                        { viewAccess: false, editAccess: false, title: "Medication" },
                        { viewAccess: false, editAccess: false, title: "Laboratory" },
                        { viewAccess: false, editAccess: false, title: "Glucose Log" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Test Report" },
                        { viewAccess: false, editAccess: false, title: "Print Order Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "History",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Medical History" },
                        { viewAccess: false, editAccess: false, title: "Hospitalization History" },
                        { viewAccess: false, editAccess: false, title: "Social History" },
                        { viewAccess: false, editAccess: false, title: "Family History" },
                    ]
                },
                { viewAccess: false, editAccess: false, title: "Discharge Summary" },
                { viewAccess: false, editAccess: false, title: "Surgery Notes" },
                { viewAccess: false, editAccess: false, title: "Form 4/4A" },
                { viewAccess: false, editAccess: false, title: "Insurance" },
                { viewAccess: false, editAccess: false, title: "Corporate" },
            ]
        }, {
            image: ImagePaths.BillOff.default,
            title: "Billing",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: 'Laboratory Billing' },
                { viewAccess: false, editAccess: false, title: "Radiology Billing" },
                { viewAccess: false, editAccess: false, title: "Multi Billing" },
            ]
        }, {
            image: ImagePaths.BillingOff.default,
            title: "Billing Transaction",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: 'Summary' },
                { viewAccess: false, editAccess: false, title: "Overall Bills" },
                { viewAccess: false, editAccess: false, title: "Credit Bills" },
                { viewAccess: false, editAccess: false, title: "Cancelled Bills" },
                { viewAccess: false, editAccess: false, title: "Saved Bills" },
                { viewAccess: false, editAccess: false, title: "Receipt Bills" },
                { viewAccess: false, editAccess: false, title: "Day End" },
                { viewAccess: false, editAccess: false, title: "Expenses" },
                { viewAccess: false, editAccess: false, title: "Detailed Receipt Bills" },
                { viewAccess: false, editAccess: false, title: "Advance Deduction Detailed" },
                { viewAccess: false, editAccess: false, title: "Day End Denomination" },
            ]
        },
        {
            image: ImagePaths.LabReportOff.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                {
                    viewAccess: false, editAccess: false, title: "OP Service Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "OP Service Detailed" },
                        { viewAccess: false, editAccess: false, title: "OP Service Overview" },
                        { viewAccess: false, editAccess: false, title: "OP Service Share" },
                        { viewAccess: false, editAccess: false, title: "Consultation Wise Report" },
                        { viewAccess: false, editAccess: false, title: "OP GST Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "IP Service Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "IP Service Detailed" },
                        { viewAccess: false, editAccess: false, title: "IP Service Overview" },
                        { viewAccess: false, editAccess: false, title: "IP Service Share" },
                        { viewAccess: false, editAccess: false, title: "IP Leger Report" },
                        { viewAccess: false, editAccess: false, title: "IP Admission List" },
                        { viewAccess: false, editAccess: false, title: "IP Discharge List" },
                        { viewAccess: false, editAccess: false, title: "IP Occupancy Report" },
                        { viewAccess: false, editAccess: false, title: "IP GST Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Corporate Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Corporate Patient Bill Report" },
                        { viewAccess: false, editAccess: false, title: "Corporate Payment Reports" },
                        { viewAccess: false, editAccess: false, title: "Insurance Patient Bill Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Appointment Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Patient Based Appointment Report" },
                        { viewAccess: false, editAccess: false, title: "Doctor Based Appointment Report" },
                        { viewAccess: false, editAccess: false, title: "Specialization Based Appointment Report" },
                        { viewAccess: false, editAccess: false, title: "Type Based Appointment Report" },
                        { viewAccess: false, editAccess: false, title: "TAT Report" },
                        { viewAccess: false, editAccess: false, title: "No Show Report" },
                        { viewAccess: false, editAccess: false, title: "Counsellor Surgery Conversion Report" },
                        { viewAccess: false, editAccess: false, title: "IMA Registration Report" },
                        { viewAccess: false, editAccess: false, title: "Appointment Request Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Patient Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Patient Demographics Report" },
                        { viewAccess: false, editAccess: false, title: 'Purpose Of Visit Report' },
                        { viewAccess: false, editAccess: false, title: 'Reason Diagnosis Report' },
                        { viewAccess: false, editAccess: false, title: 'Concession Report' },
                        { viewAccess: false, editAccess: false, title: 'Previous Credit Adjustment Report' },
                        { viewAccess: false, editAccess: false, title: 'SMS Report' },
                        { viewAccess: false, editAccess: false, title: 'Daywise Category Sales Report' },
                        { viewAccess: false, editAccess: false, title: 'Telemedicine Report' },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Referral Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Referral Doctor Report" },
                        { viewAccess: false, editAccess: false, title: "Referral Source Report" },
                        { viewAccess: false, editAccess: false, title: "Reference Value Report" },
                        { viewAccess: false, editAccess: false, title: "Referral Report" },
                        { viewAccess: false, editAccess: false, title: "Referral Count" },
                        { viewAccess: false, editAccess: false, title: "Referral Type Wise Patient Count" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Tally Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Generate Report" }
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Yearly Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Yearly Report" }
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Optometrist Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Optometrist List" }
                    ]
                },
                // { Commented out becoz these reports can be viewed based on the Django configuration for each user
                //     viewAccess: false, editAccess: false, title: "Account Reports",
                //     sub_tabs: [
                //         { viewAccess: false, editAccess: false, title: "Bill Wise Reports" },
                //         { viewAccess: false, editAccess: false, title: 'Advance Reports' },
                //         { viewAccess: false, editAccess: false, title: 'Refund/Cancelled Reports' },
                //         { viewAccess: false, editAccess: false, title: 'Credit Service Reports' },
                //         { viewAccess: false, editAccess: false, title: 'Credit Settlement Report' },
                //         { viewAccess: false, editAccess: false, title: 'Concession Reports' },
                //         { viewAccess: false, editAccess: false, title: 'Doctor Share Reports' },
                //     ]
                // },
                {
                    viewAccess: false, editAccess: false, title: "Ophthalmology Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Optical CRM Sales" },
                        { viewAccess: false, editAccess: false, title: "Prescription Report" }
                    ]
                }
            ]
        },
        // Setting Menu Has UI Changes So Commented
        // {
        //     image:ImagePaths.UserSetting.default,
        //     title: "Settings",
        //     viewAccess: false,
        //     editAccess: false,
        //     main_tabs: [
        //         {
        //             viewAccess: false, editAccess: false, title: "OP Service Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Service Name & Type Config" },
        //                 { viewAccess: false, editAccess: false, title: "Service Template" },
        //                 { viewAccess: false, editAccess: false, title: "Specialization" },
        //                 { viewAccess: false, editAccess: false, title: "Appointment Type" },
        //                 { viewAccess: false, editAccess: false, title: "Token Prefix" },
        //                 { viewAccess: false, editAccess: false, title: "Tag" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Referral Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Referral Source" },
        //                 { viewAccess: false, editAccess: false, title: "Referral Doctor" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Corporate Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Corporate" },
        //                 { viewAccess: false, editAccess: false, title: "Patient Details" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "User Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "User Configuration" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Demographics Layout",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Demographics Configuration" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "IP Service Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "IP Service Name & Type Config" },
        //                 { viewAccess: false, editAccess: false, title: "IP Package Configuration" },
        //                 { viewAccess: false, editAccess: false, title: "Surgery Configuration" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Room Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Hospital Configuration" },
        //                 { viewAccess: false, editAccess: false, title: "Ward Configuration" },
        //                 { viewAccess: false, editAccess: false, title: "Bed Configuration" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Layout Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Discharge Summary Layout" },
        //                 { viewAccess: false, editAccess: false, title: "Surgery Notes Layout" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Template Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Discharge Summary Template Configuration" },
        //                 { viewAccess: false, editAccess: false, title: "Surgery Notes Template Configuration" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "User Access Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "User Access" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Print Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Print Configuration" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Custom Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Custom Configuration" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Expense Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Expense Category" },
        //             ]
        //         },
        //         {
        //             viewAccess: false, editAccess: false, title: "Hospital Configuration",
        //             sub_tabs: [
        //                 { viewAccess: false, editAccess: false, title: "Hospital Configuration" },
        //                 { viewAccess: false, editAccess: false, title: "Doctor List" },
        //                 { viewAccess: false, editAccess: false, title: "Slot Configuration" },
        //             ]
        //         }]
        // },
        {
            image: ImagePaths.LabSettingOff.default,
            title: "Settings",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                {
                    viewAccess: false, editAccess: false, title: "Hospital Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Specialization" },
                        { viewAccess: false, editAccess: false, title: "Doctor List" },
                        { viewAccess: false, editAccess: false, title: "Slot Configuration" },
                        { viewAccess: false, editAccess: false, title: "Token Prefix" },
                        { viewAccess: false, editAccess: false, title: "Appointment Type" },
                        { viewAccess: false, editAccess: false, title: "Tag" },
                        { viewAccess: false, editAccess: false, title: "Custom Configuration" },
                        { viewAccess: false, editAccess: false, title: "Expense Category" },
                        { viewAccess: false, editAccess: false, title: "Hospital Configuration" },
                        { viewAccess: false, editAccess: false, title: "QMS Configuration" },
                        { viewAccess: false, editAccess: false, title: "Clinical Staff" },
                        { viewAccess: false, editAccess: false, title: "Clinical Staff Mapping" },
                        { viewAccess: false, editAccess: false, title: "Bank & Account Setup" },
                        { viewAccess: false, editAccess: false, title: "External Drug Master" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Referral Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Referral Source" },
                        { viewAccess: false, editAccess: false, title: "Referral Doctor" },
                        { viewAccess: false, editAccess: false, title: "Referral Staff" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Corporate Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Corporate" },
                        { viewAccess: false, editAccess: false, title: "Patient Details" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Room Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Block & Floor Configuration" },
                        { viewAccess: false, editAccess: false, title: "Ward Configuration" },
                        { viewAccess: false, editAccess: false, title: "Bed Configuration" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Insurance Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Insurance Configuration" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Message Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Message Request" },
                        { viewAccess: false, editAccess: false, title: "Message Configuration" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Radio therapy Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Therapy Master" },
                        { viewAccess: false, editAccess: false, title: "Treatment Region" },
                        { viewAccess: false, editAccess: false, title: "Treatment Technique" },
                        { viewAccess: false, editAccess: false, title: "Stimulator Master" },
                        { viewAccess: false, editAccess: false, title: "Immobilization Device Master" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "MRD Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Department Master" },
                        { viewAccess: false, editAccess: false, title: "Consultation Room Configuration" },
                        { viewAccess: false, editAccess: false, title: "Nurse Station" },
                        { viewAccess: false, editAccess: false, title: "Other Rooms" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Telemedicine Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Telemedicine Request" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "OP Service Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Service Name & Type Config" },
                        { viewAccess: false, editAccess: false, title: "Service Template" },
                        { viewAccess: false, editAccess: false, title: "Corporate Service Config" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "IP Service Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Surgery Configuration" },
                        { viewAccess: false, editAccess: false, title: "IP Service Name & Type Config" },
                        { viewAccess: false, editAccess: false, title: "IP Package Configuration" },
                        // { viewAccess: false, editAccess: false, title: "Drug Master" },
                        // { viewAccess: false, editAccess: false, title: "Drug Package" },
                        // { viewAccess: false, editAccess: false, title: "Assorted Package" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "MultiBilling Template Configuration",
                },
                {
                    viewAccess: false, editAccess: false, title: "Layout Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Demographics Configuration" },
                        { viewAccess: false, editAccess: false, title: "Discharge Summary Layout" },
                        { viewAccess: false, editAccess: false, title: "Surgery Notes Layout" },
                        { viewAccess: false, editAccess: false, title: "Print Configuration" },
                        { viewAccess: false, editAccess: false, title: "Billing Layout" },
                        { viewAccess: false, editAccess: false, title: "Vital Configuration" },
                        { viewAccess: false, editAccess: false, title: "Medical Record Print Configuration" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Template Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Discharge Summary Template Configuration" },
                        { viewAccess: false, editAccess: false, title: "Surgery Notes Template Configuration" },
                    ]
                },
                {
                    viewAccess: false,
                    editAccess: false,
                    title: "Card Layout Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Card Layout Configuration" },
                        { viewAccess: false, editAccess: false, title: "Inpatient Label Layout Configuration" },
                        { viewAccess: false, editAccess: false, title: "Attender Card Layout Configuration" },
                    ]
                },
            ]
        },
        ]
    },
    {
        title: "Laboratory",
        module_type: "Laboratory",
        data: [{
            image: ImagePaths.LabHomeOff.default,
            title: "Home",
            viewAccess: true,
            editAccess: false,
            main_tabs: [
                { viewAccess: true, editAccess: true, title: "Create Bill" },
                { viewAccess: false, editAccess: false, title: "Status" },
                { viewAccess: false, editAccess: false, title: "Test Report" },
                { viewAccess: false, editAccess: false, title: "For Technicians" },
                { viewAccess: false, editAccess: false, title: "Outsource List" },
                { viewAccess: false, editAccess: false, title: "Cancelled Bill" },
            ]
        }, {
            image: ImagePaths.LabReportOff.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                {
                    viewAccess: false, editAccess: false, title: "Financial Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Bill Report" },
                        { viewAccess: false, editAccess: false, title: "Receipt Bills" },
                        { viewAccess: false, editAccess: false, title: "Census Report" },
                        { viewAccess: false, editAccess: false, title: "Day End Report" },
                        { viewAccess: false, editAccess: false, title: "Corporate Bill Report" },
                        { viewAccess: false, editAccess: false, title: "Insurance Report" },
                        { viewAccess: false, editAccess: false, title: "Lab Share Report" },
                        { viewAccess: false, editAccess: false, title: "Test Census Report" },
                        { viewAccess: false, editAccess: false, title: "Day End Denomination" },
                        { viewAccess: false, editAccess: false, title: "Consultant Wise Report" },
                        { viewAccess: false, editAccess: false, title: "Expenses" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Patient Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Patient Report" },
                        { viewAccess: false, editAccess: false, title: "Diagnostic Census  Bills" },
                        { viewAccess: false, editAccess: false, title: "IP Admission List" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Business Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Referral Doctor Report" },
                        { viewAccess: false, editAccess: false, title: "Outsource Report" },
                        { viewAccess: false, editAccess: false, title: "Group Wise Report" },
                        { viewAccess: false, editAccess: false, title: "Group Wise Summary" },
                        { viewAccess: false, editAccess: false, title: "Test Wise Report" },
                        { viewAccess: false, editAccess: false, title: "Test Wise Summary" },
                        { viewAccess: false, editAccess: false, title: "Package Wise Report" },
                        { viewAccess: false, editAccess: false, title: "TAT Report" },
                        { viewAccess: false, editAccess: false, title: "Result Log Report" },
                        { viewAccess: false, editAccess: false, title: "Service Census Report" },
                    ]
                },
            ]
        }, {
            image: ImagePaths.LabInventrytOff.default,
            title: "Inventory",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Stock List" },
                { viewAccess: false, editAccess: false, title: "Active Inventory" },
                { viewAccess: false, editAccess: false, title: "Inactive Inventory" },
                { viewAccess: false, editAccess: false, title: "No Movement Inventory" },
                { viewAccess: false, editAccess: false, title: "Short Expiry Stock" },
                { viewAccess: false, editAccess: false, title: "New Product Status" },
                { viewAccess: false, editAccess: false, title: "Expired Status" }
            ]
        },
        {
            image: ImagePaths.LabPurchaseOff.default,
            title: "Purchase",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Wanted List" },
                { viewAccess: false, editAccess: false, title: "Purchase Order" },
                { viewAccess: false, editAccess: false, title: "Vendor Payment" },
                { viewAccess: false, editAccess: false, title: "Vendor List" }
            ]
        },
        {
            image: ImagePaths.LabSettingOff.default,
            title: "Settings",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                {
                    viewAccess: false, editAccess: false, title: "Lab Masters",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Department Master" },
                        { viewAccess: false, editAccess: false, title: "Container Master" },
                        { viewAccess: false, editAccess: false, title: "Specimen Master" },
                        { viewAccess: false, editAccess: false, title: "Method Master" },
                        { viewAccess: false, editAccess: false, title: "Antibiotic Master" },
                        { viewAccess: false, editAccess: false, title: "Organism Master" },
                        { viewAccess: false, editAccess: false, title: "Organism Vs Antibiotic Name" },
                        { viewAccess: false, editAccess: false, title: "Analyser Master" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Lab Configuration",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Result Configuration" },
                        { viewAccess: false, editAccess: false, title: "Package Configuration" },
                        { viewAccess: false, editAccess: false, title: "Template Configuration" },
                        { viewAccess: false, editAccess: false, title: "Doctor Share Configuration" },
                        { viewAccess: false, editAccess: false, title: "Consumable Mapping" },
                        { viewAccess: false, editAccess: false, title: "Patient Demographics" },
                        { viewAccess: false, editAccess: false, title: "Referred Doctor" },
                        { viewAccess: false, editAccess: false, title: "Outsource Configuration" },
                        { viewAccess: false, editAccess: false, title: "Outsource Mapping" },
                        { viewAccess: false, editAccess: false, title: "Lab E-Signature Configuration" },
                        { viewAccess: false, editAccess: false, title: "Print Configuration" },
                    ]
                },
            ]
        },
        ]
    },
    {
        title: "Pharmacy",
        module_type: "Pharmacy",
        data: [{
            image: ImagePaths.BillOff.default,
            title: "Billing",
            viewAccess: true,
            editAccess: false,
            main_tabs: [
                { viewAccess: true, editAccess: true, title: "Billing" },
                { viewAccess: false, editAccess: false, title: "Return Bills" },
            ]
        }, {
            image: ImagePaths.BillingOff.default,
            title: "Billing Transaction",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Overall Bills" },
                { viewAccess: false, editAccess: false, title: "Credit Bills" },
                { viewAccess: false, editAccess: false, title: "Saved Bills" },
                { viewAccess: false, editAccess: false, title: "Receipt Bills" },
                { viewAccess: false, editAccess: false, title: "Day End Denomination" },
                { viewAccess: false, editAccess: false, title: "Expenses" },
            ]
        }, {
            image: ImagePaths.LabInventrytOff.default,
            title: "Inventory",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Stock List" },
                { viewAccess: false, editAccess: false, title: "Drug List" },
                { viewAccess: false, editAccess: false, title: "Inactive Drug List" },
                { viewAccess: false, editAccess: false, title: "Stock Correction" },
                { viewAccess: false, editAccess: false, title: "New Drug Approval" },
            ]
        },
        {
            image: ImagePaths.LabPurchaseOff.default,
            title: "Purchase",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Purchase Request" },
                { viewAccess: false, editAccess: false, title: "Purchase Inward" },
                { viewAccess: false, editAccess: false, title: "Delivery Challan" },
                { viewAccess: false, editAccess: false, title: "Vendor Payment" },
                { viewAccess: false, editAccess: false, title: "Vendor List" },
                { viewAccess: false, editAccess: false, title: "Purchase Return" },
                { viewAccess: false, editAccess: false, title: "Purchase Rejection" },
                { viewAccess: false, editAccess: false, title: "Credit Note" },
                {
                    viewAccess: false, editAccess: false, title: "Wanted List",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: 'Order List' },
                        { viewAccess: false, editAccess: false, title: "Confirm Order List" },
                    ]
                },
            ]
        },
        {
            image: ImagePaths.LabReportOff.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                {
                    viewAccess: false, editAccess: false, title: "Sales",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Sales Overview" },
                        { viewAccess: false, editAccess: false, title: "Sales Detailed" },
                        { viewAccess: false, editAccess: false, title: "Sales Return" },
                        { viewAccess: false, editAccess: false, title: "Day End" },
                        { viewAccess: false, editAccess: false, title: "Sales Monthly" },
                        { viewAccess: false, editAccess: false, title: "Product Wise Sales" },
                        { viewAccess: false, editAccess: false, title: "Hsn Wise" },
                        { viewAccess: false, editAccess: false, title: "Sales Tax Wise" },
                        { viewAccess: false, editAccess: false, title: "Sales Return HSN Wise" },
                        { viewAccess: false, editAccess: false, title: "Sales Return Tax Wise" },
                        { viewAccess: false, editAccess: false, title: "Prescription Register" },
                        { viewAccess: false, editAccess: false, title: "Profit Analysis" },
                        { viewAccess: false, editAccess: false, title: "Sales Bill Tax Wise" },
                        { viewAccess: false, editAccess: false, title: "User Sales Performance" },
                        { viewAccess: false, editAccess: false, title: "Corporate Patient Bill Report" },
                        { viewAccess: false, editAccess: false, title: "Credit Settlement Report" },
                        { viewAccess: false, editAccess: false, title: "Sales Discount Report" },
                        { viewAccess: false, editAccess: false, title: "Door Delivery Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Purchase",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Purchase Overview" },
                        { viewAccess: false, editAccess: false, title: "Purchase Detailed" },
                        { viewAccess: false, editAccess: false, title: "Purchase GST" },
                        { viewAccess: false, editAccess: false, title: "Purchase Return Overview" },
                        { viewAccess: false, editAccess: false, title: "Purchase Return Detailed" },
                        { viewAccess: false, editAccess: false, title: "Purchase Monthly" },
                        // { viewAccess: false, editAccess: false, title: "Consolidated Sales" },
                        { viewAccess: false, editAccess: false, title: "Purchase Vendor Wise" },
                        { viewAccess: false, editAccess: false, title: "Purchase HSN Wise" },
                        { viewAccess: false, editAccess: false, title: "Purchase Tax Wise" },
                        { viewAccess: false, editAccess: false, title: "Purchase Return HSN Wise" },
                        { viewAccess: false, editAccess: false, title: "Purchase Return Vendor Wise" },
                        { viewAccess: false, editAccess: false, title: "Purchase Return Tax Wise" },
                        { viewAccess: false, editAccess: false, title: "Purchase Wise Enquiry" },
                        { viewAccess: false, editAccess: false, title: "Purchase Rejection" },
                        { viewAccess: false, editAccess: false, title: "Credit Note Report" },
                        { viewAccess: false, editAccess: false, title: "Purchase Bill Tax Wise" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Inventory",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Stock Overview" },
                        { viewAccess: false, editAccess: false, title: "MIS Report" },
                        { viewAccess: false, editAccess: false, title: "Expiry Stock" },
                        { viewAccess: false, editAccess: false, title: "Low Stock Drugs" },
                        { viewAccess: false, editAccess: false, title: "Drug Movement Report" },
                        // { viewAccess: false, editAccess: false, title: "No Movement Drugs" },
                        { viewAccess: false, editAccess: false, title: "Stock Correction Log Report" },
                        { viewAccess: false, editAccess: false, title: "Stock Value Detail" },
                        { viewAccess: false, editAccess: false, title: "Stock And Profit Value" },
                        { viewAccess: false, editAccess: false, title: "Stock Edit Log Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "GST",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Sales GST" },
                        { viewAccess: false, editAccess: false, title: "Return GST" },
                        { viewAccess: false, editAccess: false, title: "HSN Sales GST" },
                        { viewAccess: false, editAccess: false, title: "HSN Return GST" },
                        { viewAccess: false, editAccess: false, title: "GST Summary" },
                        { viewAccess: false, editAccess: false, title: "HSN GST Summary" },
                        { viewAccess: false, editAccess: false, title: "Net GST Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Yearly Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Yearly Report" },
                    ]
                },
            ]
        },
        {
            image: ImagePaths.InternalSalesOff.default,
            title: "Internal Sales",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Wanted List" },
                { viewAccess: false, editAccess: false, title: "Request List" },
                { viewAccess: false, editAccess: false, title: "Internal Sales Report" },
                { viewAccess: false, editAccess: false, title: "Internal Tax Report" },
                { viewAccess: false, editAccess: false, title: "Invoice Report" },
            ]
        },
        {
            image: ImagePaths.StkTransferOff.default,
            title: "Stock Transfer",
            viewAccess: false,
            editAccess: false,
            main_tabs: isBranch ? [
                {
                    viewAccess: false, editAccess: false, title: "Sub Location Transfer",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Inbound" },
                        { viewAccess: false, editAccess: false, title: "Outbound" },
                        { viewAccess: false, editAccess: false, title: "Stock Transfer Report" },
                        { viewAccess: false, editAccess: false, title: "Stock List" },
                        { viewAccess: false, editAccess: false, title: "Drug Wise Stock Transfer Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Inter Branch Stock Movement",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Wanted List" },
                        { viewAccess: false, editAccess: false, title: "Inbound" },
                        { viewAccess: false, editAccess: false, title: "Outbound" },
                        { viewAccess: false, editAccess: false, title: "Return Request" },
                        { viewAccess: false, editAccess: false, title: "Stock Transfer Report" },
                        // { viewAccess: false, editAccess: false, title: "Stock List" },
                    ]
                },
            ] :
                [
                    { viewAccess: false, editAccess: false, title: "Inbound" },
                    { viewAccess: false, editAccess: false, title: "Outbound" },
                    { viewAccess: false, editAccess: false, title: "Stock Transfer Report" },
                    { viewAccess: false, editAccess: false, title: "Stock List" },
                    { viewAccess: false, editAccess: false, title: "Drug Wise Stock Transfer Report" },
                ]
        },
        {
            image: ImagePaths.LabSettingOff.default,
            title: "Settings",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Print Configuration" },
                { viewAccess: false, editAccess: false, title: "Settings" },
                { viewAccess: false, editAccess: false, title: "Generic Name" },
                { viewAccess: false, editAccess: false, title: "User Access" },
                { viewAccess: false, editAccess: false, title: "Sub-Location" },
                // { viewAccess: false, editAccess: false, title: "Sub-Location Access" },
                { viewAccess: false, editAccess: false, title: "External Doctor List" },
            ]
        },
        ]
    },
    {
        title: "Standalone Pharmacy",
        module_type: "Standalone Pharmacy",
        data: [{
            image: ImagePaths.BillOff.default,
            title: "Billing",
            viewAccess: true,
            editAccess: false,
            main_tabs: []
        }, {
            image: ImagePaths.BillingOff.default,
            title: "Billing Transaction",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Overall Bills" },
                { viewAccess: false, editAccess: false, title: "Saved Bills" },
                { viewAccess: false, editAccess: false, title: "Receipt Bills" },
                { viewAccess: false, editAccess: false, title: "Expenses" },
            ]
        }, {
            image: ImagePaths.LabInventrytOff.default,
            title: "Inventory",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Stock List" },
                { viewAccess: false, editAccess: false, title: "Drug List" },
                { viewAccess: false, editAccess: false, title: "Inactive Drug List" },
                { viewAccess: false, editAccess: false, title: "Stock Correction" }
            ]
        },
        {
            image: ImagePaths.LabPurchaseOff.default,
            title: "Purchase",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                {
                    viewAccess: false, editAccess: false, title: "Wanted List",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: 'Order List' },
                        { viewAccess: false, editAccess: false, title: "Confirm Order List" },
                    ]
                },
                { viewAccess: false, editAccess: false, title: "Purchase Order" },
                { viewAccess: false, editAccess: false, title: "Purchase Rejection" },
                { viewAccess: false, editAccess: false, title: "Credit Note" },
                { viewAccess: false, editAccess: false, title: "Vendor Payment" },
                { viewAccess: false, editAccess: false, title: "Vendor List" },
            ]
        },
        {
            image: ImagePaths.LabReportOff.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                {
                    viewAccess: false, editAccess: false, title: "Sales",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Sales Overview" },
                        { viewAccess: false, editAccess: false, title: "Sales Detailed" },
                        { viewAccess: false, editAccess: false, title: "Sales Return" },
                        { viewAccess: false, editAccess: false, title: "Day End" },
                        { viewAccess: false, editAccess: false, title: "Sales Monthly" },
                        { viewAccess: false, editAccess: false, title: "Product Wise Sales" },
                        { viewAccess: false, editAccess: false, title: "Hsn Wise" },
                        { viewAccess: false, editAccess: false, title: "Profit Analysis" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Purchase",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Purchase Overview" },
                        { viewAccess: false, editAccess: false, title: "Purchase Detailed" },
                        { viewAccess: false, editAccess: false, title: "Purchase GST" },
                        { viewAccess: false, editAccess: false, title: "Purchase Return" },
                        { viewAccess: false, editAccess: false, title: "Purchase Monthly" },
                        { viewAccess: false, editAccess: false, title: "Consolidated Sales" },
                        { viewAccess: false, editAccess: false, title: "Purchase Rejection" },
                        { viewAccess: false, editAccess: false, title: "Credit Note Report" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Inventory",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Stock Overview" },
                        { viewAccess: false, editAccess: false, title: "MIS Report" },
                        { viewAccess: false, editAccess: false, title: "Expiry Stock" },
                        { viewAccess: false, editAccess: false, title: "Low Stock Drugs" },
                        { viewAccess: false, editAccess: false, title: "Slow Movement Drugs" },
                        { viewAccess: false, editAccess: false, title: "No Movement Drugs" },
                        { viewAccess: false, editAccess: false, title: "Stock Correction Log Report" },
                        { viewAccess: false, editAccess: false, title: "Stock Value Detail" },
                        { viewAccess: false, editAccess: false, title: "Stock And Profit Value" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "GST",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Sales GST" },
                        { viewAccess: false, editAccess: false, title: "Return GST" },
                        { viewAccess: false, editAccess: false, title: "HSN Sales GST" },
                        { viewAccess: false, editAccess: false, title: "HSN Return GST" },
                        { viewAccess: false, editAccess: false, title: "GST Summary" },
                        { viewAccess: false, editAccess: false, title: "HSN GST Summary" },
                        { viewAccess: false, editAccess: false, title: "Net GST Report" },
                    ]
                },
            ]
        },
        {
            image: ImagePaths.StkTransferOff.default,
            title: "Stock Transfer",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Inbound" },
                { viewAccess: false, editAccess: false, title: "Outbound" },
                { viewAccess: false, editAccess: false, title: "Stock Transfer Report" }
            ]
        },
        {
            image: ImagePaths.LabSettingOff.default,
            title: "Settings",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "New Drug Approval" },
                { viewAccess: false, editAccess: false, title: "Print Configuration" },
                { viewAccess: false, editAccess: false, title: "Settings" },
                { viewAccess: false, editAccess: false, title: "Generic Name" },
                { viewAccess: false, editAccess: false, title: "User Access" },
                { viewAccess: false, editAccess: false, title: "Sub-Location" },
                { viewAccess: false, editAccess: false, title: "Sub-Location Access" },
            ]
        },
        ]
    },
    {
        title: 'Radiology',
        module_type: 'Radiology',
        data: [{
            image: ImagePaths.LabHomeOff.default,
            title: "Home",
            viewAccess: true,
            editAccess: false,
            main_tabs: [
                { viewAccess: true, editAccess: false, title: "Appointments" },
                {
                    viewAccess: false, editAccess: false, title: "Reports",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Test Reports" },
                        { viewAccess: false, editAccess: false, title: "Notes" },
                    ]
                },
                {
                    viewAccess: false, editAccess: false, title: "Billing",
                    sub_tabs: [
                        { viewAccess: false, editAccess: false, title: "Create Bill" },
                        { viewAccess: false, editAccess: false, title: "Saved Bill" },
                        { viewAccess: false, editAccess: false, title: "Bills" },
                        { viewAccess: false, editAccess: false, title: "Receipts" }
                    ]
                },
                { viewAccess: false, editAccess: false, title: "Demographics" },
            ]
        }, {
            image: ImagePaths.BillingOff.default,
            title: "Billing Transaction",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Overall Bills" },
                { viewAccess: false, editAccess: false, title: "Credit Bills" },
                { viewAccess: false, editAccess: false, title: "Cancelled Bills" },
                { viewAccess: false, editAccess: false, title: "Saved Bills" },
                { viewAccess: false, editAccess: false, title: "Receipt Bills" },
                { viewAccess: false, editAccess: false, title: "Day End" },
                { viewAccess: false, editAccess: false, title: "Day End Denomination" },
                { viewAccess: false, editAccess: false, title: "Expenses" },
            ]
        }, {
            image: ImagePaths.LabReportOff.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Census Report" },
                { viewAccess: false, editAccess: false, title: "Patient Report" },
                { viewAccess: false, editAccess: false, title: "Consultant Wise Report" },
                { viewAccess: false, editAccess: false, title: "TAT Report" },
                { viewAccess: false, editAccess: false, title: "Corporate Patient Bill Report" },
            ]
        }, {
            image: ImagePaths.LabSettingOff.default,
            title: "Settings",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Service Name & Type Configuration" },
                { viewAccess: false, editAccess: false, title: "Result Template" },
                { viewAccess: false, editAccess: false, title: "Print Configuration" },
                { viewAccess: false, editAccess: false, title: "Result Configuration" },
            ]
        }]
    },
    {
        "title": "Store Sub Location",
        "module_type": "Store Sub Location",
        "data": [{
            image: ImagePaths.StoreOffIcon.default,
            title: "Store",
            viewAccess: true,
            editAccess: true,
            main_tabs: [
                { viewAccess: true, editAccess: true, title: "Generic Consumption" },
                { viewAccess: true, editAccess: true, title: "Low Stock" },
                { viewAccess: true, editAccess: true, title: "Expiry Alert" },
                { viewAccess: true, editAccess: true, title: "Inbound" },
                { viewAccess: true, editAccess: true, title: "Outbound" },
                { viewAccess: true, editAccess: true, title: "Return Request" },
                { viewAccess: true, editAccess: true, title: "Stock List" },
                { viewAccess: true, editAccess: true, title: "Stock Tranfer Report" },
                { viewAccess: true, editAccess: true, title: "Wanted List" },
                { viewAccess: true, editAccess: true, title: "Audit" },
            ]
        }]

    },
    {
        "title": "sub_location",
        "module_type": "sub_location",
        data: [{
            image: ImagePaths.BillOff.default,
            title: "Home",
            viewAccess: true,
            editAccess: true,
            main_tabs: [
                { viewAccess: true, editAccess: true, title: "Patient Billing" },
                { viewAccess: false, editAccess: false, title: "Generic Consumption" }]
        }, {
            image: ImagePaths.LabReportOff.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Stock List" },
                { viewAccess: false, editAccess: false, title: "Short Expiry" },
                { viewAccess: false, editAccess: false, title: "Credit Report" },
                { viewAccess: false, editAccess: false, title: "Consumption Report" },
                { viewAccess: false, editAccess: false, title: "Expiry Stock" },
                { viewAccess: false, editAccess: false, title: "Stock Value Detail" },
            ]
        }, {
            image: ImagePaths.StkTransferOff.default,
            title: "Stock Transfer",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Wanted List" },
                { viewAccess: false, editAccess: false, title: "Inbound" },
                { viewAccess: false, editAccess: false, title: "Outbound" },
                { viewAccess: false, editAccess: false, title: "Return Request" },
                { viewAccess: false, editAccess: false, title: "Stock Transfer Report" }
            ]
        },
        ]
    },
    //  {
    //     title: "Standalone Pharmacy",
    //     data: [{
    //         image: ImagePaths.HomeUser.default,
    //         title: "Billing",
    //         viewAccess: true,
    //         editAccess: false,
    //         main_tabs: []
    //     }, {
    //         image: ImagePaths.IpHomeUser.default,
    //         title: "Billing Transaction",
    //         viewAccess: false,
    //         editAccess: false,
    //         main_tabs: [
    //             { viewAccess: false, editAccess: false, title: "Overall Bills" },
    //             { viewAccess: false, editAccess: false, title: "Saved Bills" },
    //             { viewAccess: false, editAccess: false, title: "Receipt Bills" },
    //         ]
    //     }, {
    //         image: ImagePaths.ReportsUser.default,
    //         title: "Inventory",
    //         viewAccess: false,
    //         editAccess: false,
    //         main_tabs: [
    //             { viewAccess: false, editAccess: false, title: "Stock List" },
    //             { viewAccess: false, editAccess: false, title: "Drug List" },
    //             { viewAccess: false, editAccess: false, title: "Inactive Drug List" },
    //             { viewAccess: false, editAccess: false, title: "Stock Correction" }
    //         ]
    //     },
    //     {
    //         image: ImagePaths.BillTransUser.default,
    //         title: "Purchase",
    //         viewAccess: false,
    //         editAccess: false,
    //         main_tabs: [
    //             {
    //                 viewAccess: false, editAccess: false, title: "Wanted List",
    //                 sub_tabs: [
    //                     { viewAccess: false, editAccess: false, title: 'Order List' },
    //                     { viewAccess: false, editAccess: false, title: "Confirm Order List" },
    //                 ]
    //             },
    //             { viewAccess: false, editAccess: false, title: "Purchase Order" },
    //             { viewAccess: false, editAccess: false, title: "Vendor Payment" },
    //             { viewAccess: false, editAccess: false, title: "Vendor List" },
    //         ]
    //     },
    //     {
    //         image: ImagePaths.BillTransUser.default,
    //         title: "Reports",
    //         viewAccess: false,
    //         editAccess: false,
    //         main_tabs: [
    //             {
    //                 viewAccess: false, editAccess: false, title: "Sales",
    //                 sub_tabs: [
    //                     { viewAccess: false, editAccess: false, title: "Sales Overview" },
    //                     { viewAccess: false, editAccess: false, title: "Sales Detailed" },
    //                     { viewAccess: false, editAccess: false, title: "Sales Return" },
    //                     { viewAccess: false, editAccess: false, title: "Day End" },
    //                     { viewAccess: false, editAccess: false, title: "Sales Monthly" },
    //                     { viewAccess: false, editAccess: false, title: "Product Wise Sales" },
    //                 ]
    //             },
    //             {
    //                 viewAccess: false, editAccess: false, title: "Purchase",
    //                 sub_tabs: [
    //                     { viewAccess: false, editAccess: false, title: "Purchase Overview" },
    //                     { viewAccess: false, editAccess: false, title: "Purchase Detailed" },
    //                     { viewAccess: false, editAccess: false, title: "Purchase GST" },
    //                     { viewAccess: false, editAccess: false, title: "Purchase Return" },
    //                     { viewAccess: false, editAccess: false, title: "Purchase Monthly" },
    //                     { viewAccess: false, editAccess: false, title: "Consolidated Sales" },
    //                 ]
    //             },
    //             {
    //                 viewAccess: false, editAccess: false, title: "Inventory",
    //                 sub_tabs: [
    //                     { viewAccess: false, editAccess: false, title: "Stock Overview" },
    //                     { viewAccess: false, editAccess: false, title: "MIS Report" },
    //                     { viewAccess: false, editAccess: false, title: "Expiry Stock" },
    //                     { viewAccess: false, editAccess: false, title: "Low Stock Drugs" },
    //                     { viewAccess: false, editAccess: false, title: "Slow Movement Drugs" },
    //                     { viewAccess: false, editAccess: false, title: "No Movement Drugs" },
    //                     { viewAccess: false, editAccess: false, title: "Stock Correction Log Report" },
    //                     { viewAccess: false, editAccess: false, title: "Stock Value Report" },
    //                 ]
    //             },
    //             {
    //                 viewAccess: false, editAccess: false, title: "GST",
    //                 sub_tabs: [
    //                     { viewAccess: false, editAccess: false, title: "Sales GST" },
    //                     { viewAccess: false, editAccess: false, title: "Return GST" },
    //                     { viewAccess: false, editAccess: false, title: "HSN Sales GST" },
    //                     { viewAccess: false, editAccess: false, title: "HSN Return GST" },
    //                     { viewAccess: false, editAccess: false, title: "GST Summary" },
    //                     { viewAccess: false, editAccess: false, title: "HSN GST Summary" },
    //                 ]
    //             },
    //             {
    //                 viewAccess: false, editAccess: false, title: "Pharmacy",
    //                 sub_tabs: [
    //                     { viewAccess: false, editAccess: false, title: "Refferal Doctor" },
    //                     { viewAccess: false, editAccess: false, title: "Patient" },
    //                 ]
    //             },
    //             {
    //                 image: ImagePaths.UserSetting.default,
    //                 title: "Settings",
    //                 viewAccess: false,
    //                 editAccess: false,
    //                 main_tabs: [
    //                     { viewAccess: false, editAccess: false, title: "New Drug Approval" },
    //                     { viewAccess: false, editAccess: false, title: "Print Configuration" },
    //                     { viewAccess: false, editAccess: false, title: "Settings" },
    //                     { viewAccess: false, editAccess: false, title: "Generic Name" },
    //                     { viewAccess: false, editAccess: false, title: "User Access" },
    //                     { viewAccess: false, editAccess: false, title: "Referral Doctors" },
    //                 ]
    //             },
    //         ]
    //     },
    //     ]
    // }
    // Commented For we have two Standalone Pharmacy
]

export let NEW_MODULE_LIST_DATA = [
    {
        "title": "front_office",
        "module_type": "front_office",
        "data": [
            {
                "image": ImagePaths.LabHomeOff.default,
                "title": "Home",
                "viewAccess": true,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "OP Appointments"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Demographics"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Billing",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Draft"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Bills"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Receipts"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Order",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Create Order"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Order List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Cancelled Order"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Nurse Notes",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Vitals"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Treatment Plan"
                            }
                        ]

                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Doctor Visit Reports"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Test Reports"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Corporate",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Claim Details"
                            }
                        ]

                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Patient Document"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Form 4/4A"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Discharge Summary Reports"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Surgery Reports"
                    }
                ]
            },
            {
                "image": ImagePaths.IpHomeOff.default,
                "title": "In Patients",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Patient Details"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Service Billing",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Bills"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Receipts"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Order",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Create Order"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Order List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Cancelled Order"
                            }

                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Room Change"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Receive Payment"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Clinical Notes",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Vitals"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Nurse Assessments"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Doctor Notes"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Progressive Notes"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Nurse Notes"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IV / IM Track"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Drug Chart"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Pain Chart"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Nutrition Chart"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Input/OutPut Chart"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Medication"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Test Order"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Glucose Log"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Test Report"
                            },
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "History",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Medical History"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Hospitalization History"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Social History"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Family History"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Discharge Summary"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Surgery Notes"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Patient Document"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Form 4/4A"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Insurance",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Insurance Details"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Pre Authorization"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Claim Details"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Corporate",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Claim Details"
                            },
                        ]

                    }
                ]
            },
            {
                "image": ImagePaths.WalkinOff.default,
                "title": "RT WalkIn",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    { viewAccess: false, editAccess: false, title: 'Radiotherapy WalkIn' },
                ]
            },
            {
                "image": ImagePaths.BillOff.default,
                "title": "Hospital Billing",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Hospital Billing"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cash Counter"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pending List"
                    },
                ]
            },
            {
                "image": ImagePaths.BillingOff.default,
                "title": "Billing Transaction",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Billing & Collection Summary"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Overall Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Credit Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Order"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cancelled Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Draft Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Receipt Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Day End"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Expenses"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Detailed Receipt Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Advance Deduction Detailed"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Day End Denomination"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Maker/Checker Transactions"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Membership Bills"
                    }
                ]
            },
            // {
            //     "image": ImagePaths.ReportsUser.default,
            //     "title": "Credit Settlement",
            //     "viewAccess": false,
            //     "editAccess": false,
            //     "main_tabs": [
            //         {
            //             "viewAccess": false,
            //             "editAccess": false,
            //             "title": "Insurance Provider"
            //         },
            //         {
            //             "viewAccess": false,
            //             "editAccess": false,
            //             "title": "Corporate Provider"
            //         },
            //         {
            //             "viewAccess": false,
            //             "editAccess": false,
            //             "title": "Patient Provider"
            //         },
            //     ]
            // },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "OP Service Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "OP Service Detailed"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "OP Service Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "OP Service Share"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Consultation Wise Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "OP GST Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "OP Service Head-Wise Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "IP Service Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Service Detailed"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Service Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Service Share"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Admission List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Discharge List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Occupancy Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP GST Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Service Head-Wise Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Corporate Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Corporate Patient Bill Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Corporate Payment Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Insurance Patient Bill Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Appointment Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Patients Appointment Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Doctors Appointment Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Specialization Appointment Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Appointment Type Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "TAT Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "No Show Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Counsellor Surgery Conversion Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IMA Registration Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Appointment Request Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Patient Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Patient Demographics"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purpose Of Visit Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Reason / Diagnosis Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Concession Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Previous Credit Adjustment Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Day-wise Category Sales Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Credit Settlement Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Membership Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Message Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Telemedicine Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Referral Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referral Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referral Count"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referral Type Wise Patient Count"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Ophthalmology Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Optical CRM Sales"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Prescription Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Optometrist Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Optometrist List"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Generate Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Generate Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Yearly Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Yearly Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Account Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Bill Wise Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Advance Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Refund/Cancelled Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Credit Service Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Credit Settlement Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Concession Reports"
                            },
                        ]
                    },
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Settings",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Hospital Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Specialization"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Doctor List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Slot Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Token Prefix"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Appointment Type"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Tag"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Custom Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Expense Category"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Hospital Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Clinic Staff"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Clinic Staff Mapping"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "QMS Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purpose of Visit"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Diagnosis Reason"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Optometrist Mapping"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Bank & Account Setup"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "External Drug Master"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Referral Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referral Source"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referral Doctor"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referral Staff"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Corporate Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Corporate"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Patient Details"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Room Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Block & Floor Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Ward Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Bed Configuration"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Insurance Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Insurance Configuration"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Message Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Message Request"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Message Configuration"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "MRD Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Department Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Consultation Room Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Nurse Station"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Other Rooms"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Telemedicine Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Telemedicine Request"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Membership Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Package Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Membership Creation"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Telemedicine Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Telemedicine Request"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Therapy Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Therapist Master"
                            },
                        ]
                    },
                    // {
                    //     "viewAccess": false,
                    //     "editAccess": false,
                    //     "title": "OP Service Configuration",
                    //     "sub_tabs": [
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "Service Name & Type Config"
                    //         },
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "Service Template"
                    //         },
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "Corporate Service Config"
                    //         }
                    //     ]
                    // },
                    // {
                    //     "viewAccess": false,
                    //     "editAccess": false,
                    //     "title": "IP Service Configuration",
                    //     "sub_tabs": [
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "Surgery Configuration"
                    //         },
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "IP Service Name & Type Config"
                    //         },
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "IP Package Configuration"
                    //         },
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "Drug Master"
                    //         },
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "Drug Package"
                    //         },
                    //         {
                    //             "viewAccess": false,
                    //             "editAccess": false,
                    //             "title": "Assorted Package"
                    //         },

                    //     ]
                    // },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Service Master Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Service Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Holiday/Emergency"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Auto Billing"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Template Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Package Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Corporate Service Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Insurance Package Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Surgery Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Surgery Mapping"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Drug Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Drug Template"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Assorted Package"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Layout Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Demographics Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Discharge Summary Layout"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Surgery Notes Layout"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Print Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Vital Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Doctor Notes Layout"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Detailed Print Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Medical Record Print Configuration"
                            },

                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Template Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Discharge Summary Template Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Surgery Notes Template Configuration"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Card Layout Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Card Layout Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Inpatient Label Layout Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Attender Card Layout Configuration"
                            }
                        ]
                    },
                ]
            }
        ]
    },
    {
        "title": "Standalone Pharmacy",
        "module_type": "Standalone Pharmacy",
        "data": [
            {
                "image": ImagePaths.BillOff.default,
                "title": "Billing",
                "viewAccess": true,
                "editAccess": false,
                "main_tabs": []
            },
            {
                "image": ImagePaths.BillingOff.default,
                "title": "Billing Transaction",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Overall Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Saved Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Receipt Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Expenses"
                    },
                ]
            },
            {
                "image": ImagePaths.LabInventrytOff.default,
                "title": "Inventory",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Drug List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inactive Drug List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock Correction"
                    }
                ]
            },
            {
                "image": ImagePaths.LabPurchaseOff.default,
                "title": "Purchase",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Wanted List",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Order List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Confirm Order List"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Order"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Rejection"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Credit Note"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor Payment"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor List"
                    }
                ]
            },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Sales",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Detailed"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Return"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Day End"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Monthly"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Product Wise Sales"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Hsn Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Profit Analysis"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Detailed"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Monthly"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Consolidated Sales"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Rejection"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Credit Note Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inventory",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "MIS Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Expiry Stock"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Low Stock Drugs"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Slow Movement Drugs"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "No Movement Drugs"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Correction Log Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Value Detail"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock And Profit Value"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "GST",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Return GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "HSN Sales GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "HSN Return GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "GST Summary"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "HSN GST Summary"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Net GST Report"
                            }
                        ]
                    }
                ]
            },
            {
                image: ImagePaths.InternalSalesOff.default,
                title: "Internal Sales",
                viewAccess: false,
                editAccess: false,
                main_tabs: [
                    { viewAccess: false, editAccess: false, title: "Wanted List" },
                    { viewAccess: false, editAccess: false, title: "Request List" },
                    { viewAccess: false, editAccess: false, title: "Sales Report" },
                    { viewAccess: false, editAccess: false, title: "Internal Tax Report" },
                    { viewAccess: false, editAccess: false, title: "Invoice Report" },
                ]
            },
            {
                "image": ImagePaths.StkTransferOff.default,
                "title": "Stock Transfer",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inbound"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Outbound"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock Transfer Report"
                    }
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Settings",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "New Drug Approval"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Print Configuration"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Settings"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Generic Name"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "User Access"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Sub-Location"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Sub-Location Access"
                    }
                ]
            }
        ]
    },
    {
        "title": "Rajesh Radiology",
        "module_type": "Radiology",
        "data": [
            {
                "image": ImagePaths.LabHomeOff.default,
                "title": "Home",
                "viewAccess": true,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "Appointments"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Test Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Notes"
                            },
                        ]
                    },
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "Order"
                    },
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "Demographics"
                    },
                ]
            },
            {
                "image": ImagePaths.BillOff.default,
                "title": "Radiology Billing",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Hospital Billing"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cash Counter"
                    }, {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pending List"
                    },
                ]
            },
            {
                "image": ImagePaths.BillingOff.default,
                "title": "Billing Transaction",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Overall Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Credit Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cancelled Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Saved Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Receipt Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Day End"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Day End Denomination"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Expenses"
                    },
                ]
            },
            {
                "image": ImagePaths.OrderOffIcon.default,
                "title": "Order",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Create Order"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pending List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Accepted Order"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cancelled Order"
                    }
                ]
            },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Census Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Patient Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Consultant Wise Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "TAT Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Corporate Patient Bill Report"
                    }
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Settings",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Result Template"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Print Configuration"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Result Configuration"
                    },
                ]
            }
        ]
    },
    {
        "title": "Investigation",
        "module_type": "Investigation",
        "data": [
            {
                "image": ImagePaths.LabHomeOff.default,
                "title": "Home",
                "viewAccess": true,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "Appointments"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Test Reports"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Notes"
                            },
                        ]
                    },
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "Order"
                    },
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "Demographics"
                    },
                ]
            },
            {
                "image": ImagePaths.BillOff.default,
                "title": "Investigation Billing",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Hospital Billing"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cash Counter"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pending List"
                    },
                ]
            },
            {
                "image": ImagePaths.BillingOff.default,
                "title": "Billing Transaction",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Overall Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Credit Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cancelled Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Saved Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Receipt Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Day End"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Day End Denomination"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Expenses"
                    }
                ]
            },
            {
                "image": ImagePaths.OrderOffIcon.default,
                "title": "Order",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Create Order"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pending List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Accepted Order"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cancelled Order"
                    }
                ]
            },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Census Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Patient Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Consultant Wise Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "TAT Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Corporate Patient Bill Report"
                    }
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Settings",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Result Template"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Print Configuration"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Result Configuration"
                    },
                ]
            }
        ]
    },
    {
        "title": "Laboratory",
        "module_type": "Laboratory",
        "data": [
            {
                "image": ImagePaths.LabHomeOff.default,
                "title": "Home",
                "viewAccess": true,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Create Patient"
                    },
                    {
                        "viewAccess": true,
                        "editAccess": false,
                        "title": "Status"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Test Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "For Technicians"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Outsource List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Order"
                    }
                ]
            },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Financial Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Bill Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Receipt Bills"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Census Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Day End Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Corporate Bill Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Insurance Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Lab Share Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Test Census Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Day End Denomination"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Consultant Wise Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Expenses"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Patient Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Patient Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Diagnostic Census  Bills"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "IP Admission List"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Business Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referral Doctor Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Outsource Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Group Wise Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Group Wise Summary"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Test Wise Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Test Wise Summary"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Package Wise Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "TAT Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Result Log Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Service Census Report"
                            }
                        ]
                    }
                ]
            },
            {
                "image": ImagePaths.BillOff.default,
                "title": "Lab Billing",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Hospital Billing"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cash Counter"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pending List"
                    },
                ]
            },
            {
                "image": ImagePaths.LabInventrytOff.default,
                "title": "Inventory",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Active Inventory"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inactive Inventory"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "No Movement Inventory"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Short Expiry Stock"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "New Product Status"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Expired Status"
                    }
                ]
            },
            {
                "image": ImagePaths.LabPurchaseOff.default,
                "title": "Purchase",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Wanted List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Order"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor Payment"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor List"
                    }
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Settings",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Lab Masters",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Department Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Container Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Specimen Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Method Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Antibiotic Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Organism Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Organism Vs Antibiotic Name"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Analyser Master"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Lab Configuration",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Result Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Consumable Mapping"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Patient Demographics"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Referred Doctor"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Outsource Configuration"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Outsource Mapping"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Lab E-Signature Configuration"
                            },
                            { "viewAccess": false, "editAccess": false, title: "Print Configuration" },
                        ]
                    }
                ]
            }
        ]
    },
    {
        "title": "Pharmacy",
        "module_type": "Pharmacy",
        "data": [
            {
                "image": ImagePaths.BillOff.default,
                "title": "Billing",
                "viewAccess": true,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": true,
                        "editAccess": true,
                        "title": "Billing"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Return Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Cash Counter"
                    }
                ]
            },
            {
                "image": ImagePaths.BillingOff.default,
                "title": "Billing Transaction",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Overall Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Credit Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Saved Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Receipt Bills"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Day End Denomination"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Expenses"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pharmacy Advance Adjusted Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Pharmacy Advance Re-Added Report"
                    },
                ]
            },
            {
                "image": ImagePaths.LabInventrytOff.default,
                "title": "Inventory",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Drug List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inactive Drug List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock Correction"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "New Drug Approval"
                    }
                ]
            },
            {
                "image": ImagePaths.LabPurchaseOff.default,
                "title": "Purchase",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Request"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Inward"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Delivery Challan"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor Payment"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Return"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Rejection"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Credit Note"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Wanted List",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Order List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Confirm Order List"
                            }
                        ]
                    }
                ]
            },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Sales Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Detailed"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Return"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Day End"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Monthly"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Product Wise Sales"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Hsn Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Tax Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Return HSN Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Return Tax Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Prescription Register"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Profit Analysis"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Bill Tax Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "User Sales Performance"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Corporate Patient Bill Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Credit Settlement Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales Discount Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Door Delivery Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Issued Drug Report"
                            },
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Detailed"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return Detailed"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Monthly"
                            },
                            // {
                            //     "viewAccess": false,
                            //     "editAccess": false,
                            //     "title": "Consolidated Sales"
                            // },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Vendor Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase HSN Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Tax Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return HSN Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return Vendor Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return Tax Wise"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Wise Enquiry"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Rejection"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Credit Note Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Bill Tax Wise"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inventory Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Overview"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "MIS Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Expiry Stock"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Low Stock Drugs"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Drug Movement Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Correction Log"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Value Detail"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock And Profit Value"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Edit Log Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "GST Reports",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Sales GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Return GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "HSN Sales GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "HSN Return GST"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "GST Summary"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "HSN GST Summary"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Net GST Report"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Accounts Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Generate Report"
                            }
                        ]
                    }
                ]
            },
            {
                'image': ImagePaths.InternalSalesOff.default,
                'title': "Internal Sales",
                'viewAccess': false,
                'editAccess': false,
                'main_tabs': [
                    { 'viewAccess': false, 'editAccess': false, 'title': "Wanted List" },
                    { 'viewAccess': false, 'editAccess': false, 'title': "Request List" },
                    { 'viewAccess': false, 'editAccess': false, 'title': "Internal Sales Report" },
                    { 'viewAccess': false, 'editAccess': false, 'title': "Internal Tax Report" },
                    { 'viewAccess': false, 'editAccess': false, 'title': "Invoice Report" },
                ]
            },
            {
                "image": ImagePaths.StkTransferOff.default,
                "title": "Stock Transfer",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inbound"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Outbound"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock Transfer Report"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Drug Wise Stock Transfer Report"
                    }
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Settings",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Print Configuration"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Settings"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Generic Name"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "User Access"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Sub-Location"
                    },
                    // {
                    //     "viewAccess": false,
                    //     "editAccess": false,
                    //     "title": "Sub-Location Access"
                    // },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "External Doctor List"
                    }
                ]
            }
        ]
    },
    {
        "title": "store_module",
        "module_type": "store_module",
        "data": [
            {
                "image": ImagePaths.LabPurchaseOff.default,
                "title": "Purchase",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Request"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Inward"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Rejection"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Credit Note"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Audit"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor Payment"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Wanted List"
                    }
                ]
            },
            {
                "image": ImagePaths.LabInventrytOff.default,
                "title": "Inventory",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Product List"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock Correction"
                    }
                ]
            },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inventory Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Value Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stock Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Short Expiry"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Low Stock"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Purchase Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Request"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase HSN Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase GST Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return HSN Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Purchase Return GST Report"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Vendor Performance"
                            }
                        ]
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Transfer Report",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Transfer List"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Return Transfer Sublocation"
                            },
                        ]
                    }
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Masters",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Department"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Category"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Sub Category"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Product Type"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Products"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Vendor Mapping"
                    }
                ]
            },
            {
                "image": ImagePaths.StoreOffIcon.default,
                "title": "Store",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Inbound"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Outbound"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stock Tranfer Report"
                    }
                ]
            },
        ]
    },
    {
        "title": "Store Sub Location",
        "module_type": "Store Sub Location",
        "data": [{
            image: ImagePaths.StoreOffIcon.default,
            title: "Store",
            viewAccess: true,
            editAccess: true,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Generic Consumption" },
                { viewAccess: false, editAccess: false, title: "Low Stock" },
                { viewAccess: false, editAccess: false, title: "Expiry Alert" },
                { viewAccess: false, editAccess: false, title: "Inbound" },
                { viewAccess: false, editAccess: false, title: "Outbound" },
                { viewAccess: false, editAccess: false, title: "Return Request" },
                { viewAccess: false, editAccess: false, title: "Stock List" },
                { viewAccess: false, editAccess: false, title: "Stock Tranfer Report" },
                { viewAccess: false, editAccess: false, title: "Wanted List" },
                { viewAccess: false, editAccess: false, title: "Audit" },
            ]
        }]

    },
    {
        "title": "master_record_department",
        "module_type": "master_record_department",
        "data": [
            {
                "image": ImagePaths.LabHomeOff.default,
                "title": "Home",
                "viewAccess": true,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "MRD Home"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Transfer Request",
                    },
                ]
            },
            {
                "image": ImagePaths.LabReportOff.default,
                "title": "Audit Track",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Audit Track"
                    }
                ]
            },
            {
                "image": ImagePaths.LabSettingOff.default,
                "title": "Masters",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "MRD Category"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "MRD Rack"
                    }
                ]
            }
        ]
    },
    {
        "title": "sub_location",
        "module_type": "sub_location",
        data: [{
            image: ImagePaths.BillOff.default,
            title: "Home",
            viewAccess: true,
            editAccess: true,
            main_tabs: [
                { viewAccess: true, editAccess: true, title: "Patient Billing" },
                { viewAccess: false, editAccess: false, title: "Generic Consumption" }]
        }, {
            image: ImagePaths.LabReportOff.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Stock List" },
                { viewAccess: false, editAccess: false, title: "Short Expiry" },
                { viewAccess: false, editAccess: false, title: "Credit Report" },
                { viewAccess: false, editAccess: false, title: "Consumption Report" },
                { viewAccess: false, editAccess: false, title: "Expiry Stock" },
                { viewAccess: false, editAccess: false, title: "Stock Value Detail" },
                { viewAccess: false, editAccess: false, title: "Issued Drug Report" },
            ]
        }, {
            image: ImagePaths.StkTransferOff.default,
            title: "Stock Transfer",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Wanted List" },
                { viewAccess: false, editAccess: false, title: "Inbound" },
                { viewAccess: false, editAccess: false, title: "Outbound" },
                { viewAccess: false, editAccess: false, title: "Return Request" },
                { viewAccess: false, editAccess: false, title: "Stock Transfer Report" }
            ]
        },

        ]
    },
]

export let RADIOTHERAPY_USERACCESS_JSON = [
    {
        title: "Radiotherapy",
        module_type: "Radiotherapy",
        data: [
            {
                "image": ImagePaths.HomeUser.default,
                "title": "Stimulation",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Stimulation"
                    }
                ]
            },
            {
                "image": ImagePaths.HomeUser.default,
                "title": "Dosimetrist",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Dosimetrist"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Therapy Plan"
                    }
                ]
            },
            {
                "image": ImagePaths.HomeUser.default,
                "title": "Scheduler",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Scheduler"
                    }
                ]
            },
            {
                "image": ImagePaths.HomeUser.default,
                "title": "Therapist",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Therapist"
                    },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Therapy Session"
                    }
                ]
            },
            {
                "image": ImagePaths.HomeUser.default,
                "title": "Reports",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    // {
                    //     "viewAccess": false,
                    //     "editAccess": false,
                    //     "title": "RT Treatment Report"
                    // },
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "RT Session TAT Report"
                    }
                ]
            },
            {
                "image": ImagePaths.HomeUser.default,
                "title": "Settings",
                "viewAccess": false,
                "editAccess": false,
                "main_tabs": [
                    {
                        "viewAccess": false,
                        "editAccess": false,
                        "title": "Radiotherapy Masters",
                        "sub_tabs": [
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Therapy Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Treatment Region"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Therapy Technique"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Stimulator Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Immobilization Device Master"
                            },
                            {
                                "viewAccess": false,
                                "editAccess": false,
                                "title": "Radiotherapy Tag"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]

export const toast_Time_out = 6000
export const cmt_Char_limit = 250
// export const OPTICAL_CRM_API_MODE = "Test"
export const NO_Internet_Connection = "No Internet. Please Check Your Internet Connection !"
export const OPTICAL_CRM_API_MODE = "Live"

export const Permission_Access = {
    op: {
        is_credit: false,
        is_pov_editable: false,
    },
    ip: {
        is_credit: false,
    },
    lab: {
        is_credit: false,
    },
    pharma: {
        is_credit: false,
        isShowPo: false,
        isDiscountEdit: false,
        isViewRpt: "last7days",
        isEditSave: false,
        isCrtDrug: false,
        isApprover: false,
        isViewMargin: false,
        isReturnBill: true,
        isGRNEntry: true,
        isPOrequestApprove: false,
        isReceivePayment:true,
        isGRNEntry : true,
        isRetrunRefundPayment : true
    },
    common: {
        change_payment_mode: false,
        modify_credit_bill: false,
        cancel_bill_approval: false,
        is_demographics_edit: false,
        safety_deposit_permission: false,
        cash_counter: false,
        show_order_amounts: false,
        edit_order_amounts: false,
        allow_concession: true,
        allow_final_bill: true,
        can_view_dashboard: false,
    },
    cash_counter_modules: [],
    show_cash_counter_for: []
}
export const Sub_Permission_Access = {
    discount_edit: false,
    margin_profit: false,
    indent_approve: false,
    stock_correction: false,
}

export const paymentList = [
    { value: 1, label: "Cash" },
    { value: 2, label: "Card" },
    { value: 3, label: "UPI" },
    { value: 4, label: "Cheque" },
    { value: 5, label: "BankTransfer" }
]

export const Expiry_period = [
    { label: "", value: '0' },
    { label: "1 month", value: '1' },
    { label: "2 months", value: '2' },
    { label: "3 months", value: '3' },
    { label: "6 months", value: '6' },
]
export const gstPercentage = [
    { label: "0%", value: "0" },
    { label: "5%", value: "5" },
    { label: "12%", value: "12" },
    { label: "18%", value: "18" },
    { label: "28%", value: "28" },
    { label: "40%", value: "40" },
]
export const gstPercentageConfig = [
    { label: "0", value: "0" },
    { label: "5", value: "5" },
    { label: "12", value: "12" },
    { label: "18", value: "18" },
    { label: "28", value: "28" },
    { label: "40", value: "40" }
]
export const DrugApproveList = [
    { value: "All", label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "Accepted", label: "Approved" },
    { value: "Declined", label: "Declined" },
]

export const SUBLOCATION_LIST_DATA = [
    {
        sub_title: "sub_location",
        data: [{
            image: ImagePaths.HomeUser.default,
            title: "Home",
            viewAccess: true,
            editAccess: true,
            main_tabs: [
                { viewAccess: true, editAccess: true, title: "Patient Billing" },
                { viewAccess: false, editAccess: false, title: "Generic Consumption" }]
        }, {
            image: ImagePaths.BillTransUser.default,
            title: "Reports",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Stock List" },
                { viewAccess: false, editAccess: false, title: "Short Expiry" },
                { viewAccess: false, editAccess: false, title: "Credit Report" },
                { viewAccess: false, editAccess: false, title: "Consumption Report" },
                { viewAccess: false, editAccess: false, title: "Stock Value Detail" },
            ]
        }, {
            image: ImagePaths.ReportsUser.default,
            title: "Stock Transfer",
            viewAccess: false,
            editAccess: false,
            main_tabs: [
                { viewAccess: false, editAccess: false, title: "Wanted List" },
                { viewAccess: false, editAccess: false, title: "Inbound" },
                { viewAccess: false, editAccess: false, title: "Outbound" },
                { viewAccess: false, editAccess: false, title: "Return Request" },
                { viewAccess: false, editAccess: false, title: "Stock Transfer Report" }
            ]
        },

        ]
    }

]

//DOCTOR MODULE CONSTANTS =======>

export const Medical_History_Problems = [
    { label: "Joint Pain", value: "Joint Pain" },
    { label: "Asthma", value: "Asthma" },
    { label: "Seizures", value: "Seizures" },
    { label: "Stroke", value: "Stroke" },
    { label: "Blood Problems", value: "Blood Problems" },
    { label: "Cancer", value: "Cancer" },
    { label: "Heart Disease", value: "Heart Disease" },
    { label: "Thyroid Disorder", value: "Thyroid Disorder" },
    { label: "High BP", value: "High BP" },
    { label: "Diabetes / Blood Sugar", value: "Diabetes / Blood Sugar" },
    { label: "Mental Illness", value: "Mental Illness" },
    { label: 'Others', value: 'Others' }
]

export const Medical_History_Blood_Group = [
    { label: "O-Ve", value: "O-Ve" },
    { label: "O+Ve", value: "O+Ve" },
    { label: "A-Ve", value: "A-Ve" },
    { label: "A+Ve", value: "A+Ve" },
    { label: "AB-Ve", value: "AB-Ve" },
    { label: "AB+Ve", value: "AB+Ve" },
    { label: "B+Ve", value: "B+Ve" },
    { label: "B-Ve", value: "B-Ve" },
]

export const Hospital_For_List = [
    { label: "Hospitalised", value: "Hospitalised" },
    { label: "Surgery", value: "Surgery" }
]

export const Smoking_List = [
    { label: "Occasionally", value: "Occasionally" },
    { label: "1-2 cigarettes per day", value: "1-2 cigarettes per day" },
    { label: "1 pack per day", value: "1 pack per day" },
]

export const Daily_Activity_List = [
    { label: "Sitting most of the day", value: "Sitting most of the day" },
    { label: "Some activity daily", value: "Some activity daily" },
    { label: "Very active daily", value: "Very active daily" }
]

export const Alcohol_List = [
    { label: "Occasionally", value: "Occasionally" },
    { label: "Social Only", value: "Social Only" },
    { label: "Frequently", value: "Frequently" },

]

export const Diet_Type_List = [
    { label: "Vegetarian", value: "Vegetarian" },
    { label: "Vegan", value: "Vegan" },
    { label: "Eggetarian", value: "Eggetarian" },
    { label: "Non Vegetarian", value: "Non Vegetarian" },
]

export const Mental_Status_List = [
    { label: "Normal", value: "Normal" },
    { label: "Anxious", value: "Anxious" },
    { label: "Depressed", value: "Depressed" },
    { label: "Stressed", value: "Stressed" },
    { label: "Confused", value: "Confused" },
    { label: "Manic", value: "Manic" },
]


export const Birth_Control_List = [
    { label: "Condoms", value: "Condoms" },
    { label: "Birth Control Pills", value: "Birth Control Pills" },
    { label: "Implants", value: "Implants" },
    { label: "IUD", value: "IUD" },
    { label: "Vasectomy", value: "Vasectomy" },
    { label: "Timing", value: "Timing" },
    { label: "Diaphagram", value: "Diaphagram" },
    { label: "Patch", value: "Patch" },
    { label: "Deepo provera", value: "Deepo provera" },
    { label: "Tubal Ligation", value: "Tubal Ligation" },
    { label: "Ring", value: "Ring" }
]

export const GYN_History_List = [
    { label: "Veneral Warts", value: "Veneral Warts" },
    { label: "Herpes Genital", value: "Herpes Genital" },
    { label: "Syphilis", value: "Syphilis" },
    { label: "Pelvic Inflammatory", value: "Pelvic Inflammatory" },
    { label: "Vaginal Infections", value: "Vaginal Infections" },
    { label: "Endometriosis", value: "Endometriosis" },
    { label: "Chlamydia", value: "Chlamydia" },
    { label: "Gonorrhoea", value: "Gonorrhoea" }
]

export const Yes_Or_No = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" }
]

export const Drug_List = [
    { label: "Smokes Marijuana", value: "Smokes Marijuana" },
    { label: "Cocaine", value: "Cocaine" },
    { label: "LSD", value: "LSD" },
    { label: "Intravenous Drugs", value: "Intravenous Drugs" }
]

export const Family_Member_List = [
    { label: "Father", value: "Father" },
    { label: "Mother", value: "Mother" },
    { label: "Brother", value: "Brother" },
    { label: "Sister", value: "Sister" }
]

export const Prescription_Days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
]

export const Years_of_Diabetics = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
]

export const Types_of_Diabetic = [
    { label: "Type 1", value: "1" },
    { label: "Type 2", value: "2" },
    { label: "Not Sure", value: "0" },
]

export const Treated_of_Diabetic = [
    { label: "Blood Glucose Pills", value: "Blood Glucose Pills" },
    { label: "Insulin Injections", value: "Insulin Injections" },
    { label: "Diet Exercises", value: "Diet Exercises" },
]

export const Name_of_Bg_Meter = [
    { label: "ACCU-CHEK AVIVA NANO", value: "ACCU-CHEK AVIVA NANO" },
    { label: "ACCU-CHEK MOBILE", value: "ACCU-CHEK MOBILE" },
    { label: "ABBOTTI DIABETES CARE", value: "ABBOTTI DIABETES CARE" },
]

export const Blood_GLucouse_Test = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" }
]

export const High_Glucouse_Test = [
    { label: "Frequent Urination", value: "Frequent Urination" },
    { label: "Feet-Numbness/Tingling", value: "Feet-Numbness/Tingling" },
    { label: "Slow healing Wounds", value: "Slow healing Wounds" },
    { label: "Unexplained weight loss", value: "Unexplained weight loss" },
    { label: "Frequent Thirst", value: "Frequent Thirst" },
    { label: "Pain in Feet while Resting", value: "Pain in Feet while Resting" },
    { label: "Blurred Vision", value: "Blurred Vision" },
    { label: "Increased Hunger", value: "Increased Hunger" },
    { label: "Constantly Tired", value: "Constantly Tired" },
    { label: "Frequent Infections", value: "Frequent Infections" },
]

export const Blood_Glucouse_Symptoms = [
    { label: "Headaches", value: "Headaches" },
    { label: "Shaking/Sweating", value: "Shaking/Sweating" },
    { label: "Dizziness", value: "Dizziness" },
    { label: "Poor Leg Circulation", value: "Poor Leg Circulation" },
    { label: "Irritability/Anxiety", value: "Irritability/Anxiety" },
    { label: "Intense Hunger", value: "Intense Hunger" },
    { label: "Weakness", value: "Weakness" }
]

export const Activity_Level = [
    { label: "Sitting Most of the day", value: "Sitting Most of the day" },
    { label: "Some activity daily", value: "Some activity daily" },
    { label: "Very active daily", value: "Very active daily" },

];

export const Exercises_Daily = [
    { label: "01", value: "01" },
    { label: "02", value: "02" },
    { label: "03", value: "03" },
    { label: "04", value: "04" },
    { label: "05", value: "05" },
    { label: "06", value: "06" },
    { label: "07", value: "07" },


];

export const Type_Exercise = [
    { label: "Stretching", value: "Stretching" },
    { label: "Aerobic", value: "Aerobic" },
    { label: "Resistance", value: "Resistance" },

];

export const Intensity_Level = [
    { label: "Low Intensity: you can talk easily while exercising", value: "01" },
    { label: "Moderate Intensity: You can breathe a little harder, but you can still talk", value: "02" },
    { label: "High Intensity: You breathe hard, and its difficult to talk while exercising", value: "03" },
];

export const Nutrition = [
    { value: "1", label: "Vegetarian" },
    { value: "2", label: "Vegan" },
    { value: "3", label: "Eggetarian" },
    { value: "4", label: "Non Vegetarian" },
    { value: "5", label: "Mixed" },
];

export const WaterConsumption = [
    { value: "01", label: "01" },
    { value: "02", label: "02" },
    { value: "03", label: "03" },
    { value: "04", label: "04" },
    { value: "05", label: "05" },
    { value: "06", label: "06" },
    { value: "07", label: "07" }
];

export const Allergy_Type_List = [
    { label: 'Medication Allergy', value: '1' },
    { label: 'Non-Medication Allergy', value: '2' }
]

export const Status = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
]

export const TwentyDays = [];
for (let i = 1; i <= 20; i++) {
    TwentyDays.push({
        label: i < 10 ? '0' + i?.toString() : i?.toString(),
        value: i?.toString()
    })
}

export const Days = [];
for (let i = 1; i <= 31; i++) {
    Days.push({
        label: i < 10 ? '0' + i?.toString() : i?.toString(),
        value: i?.toString()
    })
}

export const Weeks = [];
for (let i = 1; i <= 15; i++) {
    Weeks.push({
        label: i < 10 ? '0' + i?.toString() : i?.toString(),
        value: i?.toString()
    })
}
Weeks.push({ label: 'Once In a Week', value: 'Once In a Week' })
Weeks.push({ label: 'Twice In a Week', value: 'Twice In a Week' })

export const Months = [];
for (let i = 1; i <= 12; i++) {
    Months.push({
        label: i < 10 ? '0' + i?.toString() : i?.toString(),
        value: i?.toString()
    })
}
Months.push({ label: 'Once In a Month', value: 'Once In a Month' })
Months.push({ label: 'Twice In a Month', value: 'Twice In a Month' })

export const Year = [];
for (let i = 1; i <= 15; i++) {
    Year.push({
        label: i < 10 ? '0' + i?.toString() : i?.toString(),
        value: i?.toString()
    })
}
Year.push({ label: 'Chronic', value: 'Chronic' })

export const Doctor_Notes_List = [
    'Prescription', 'Previous Prescription',
    'Plan', 'General-Patient Advice']

export const defaultRouteList = [
    { label: "Oral", value: "Oral" },
    { label: "Vein", value: "Vein" },
    { label: "Subcutaneous", value: "Subcutaneous" },
    { label: "Intramuscular", value: "Intramuscular" },
    { label: "Intradermal", value: "Intradermal" },
    { label: "Intranasal", value: "Intranasal" }
]

export const MealType = [
    { value: 'Early morning', label: 'Early morning', },
    { value: 'Breakfast', label: 'Breakfast', },
    { value: 'Mid morning', label: 'Mid morning', },
    { value: 'Lunch', label: 'Lunch' },
    { value: 'Evening', label: 'Evening' },
    { value: 'Dinner', label: 'Dinner' },
    { value: 'Bedtime', label: 'Bedtime' },
]

export const Morning_Meal_type = [
    { value: 'Early morning', label: 'Early morning', },
    { value: 'Breakfast', label: 'Breakfast', },
    { value: 'Mid morning', label: 'Mid morning', }
]

export const Afternoon_Meal_type = [
    { value: 'Lunch', label: 'Lunch' }
]

export const Night_Meal_Type = [
    { value: 'Evening', label: 'Evening' },
    { value: 'Dinner', label: 'Dinner' },
    { value: 'Bedtime', label: 'Bedtime' }
]

export const FoodType = [
    { value: 'Food', label: 'Food' },
    { value: 'Liqiud', label: 'Liquid' },
]

export const UnitList = [
    { value: 'Nos', label: 'Nos' },
    { value: 'ml', label: 'ml' },
    { value: 'mg', label: 'mg' },
    { value: 'kg', label: 'kg' },
    { value: 'litre', label: 'litre' },
    { value: 'katori', label: 'katori' },
    { value: 'gram', label: 'Gram' }
]

export const Gender_List = [
    { label: 'Male', value: 'm' },
    { label: 'Female', value: 'f' },
    { label: 'Trans Gender', value: 't' }
]

export const language = [
    { label: 'English', value: 'english' },
    { label: 'Tamil', value: 'tamil' },
    { label: 'Hindi', value: 'hindi' },
]

export const TabletQty = {
    without_ml: [
        { label: '0.5', value: '0.5' },
        { label: '1', value: '1' },
        { label: '1.5', value: '1.5' },
        { label: '2', value: '2' },
        { label: '2.5', value: '2.5' },
        { label: '3', value: '3' },
        { label: '3.5', value: '3.5' },
    ],
    with_ml: [
        { label2: '2.5', value2: '2.5' },
        { label2: '5', value2: '5' },
        { label2: '7.5', value2: '7.5' },
        { label2: '10', value2: '10' },
        { label2: '15', value2: '15' },
        { label2: '20', value2: '20' },
        // { label2: '25', value2: '25' },
        // { label2: '30', value2: '30' },
    ],
    with_drops: [
        { label3: '1', value3: '1' },
        { label3: '2', value3: '2' },
        { label3: '3', value3: '3' },
        { label3: '4', value3: '4' },
        { label3: '5', value3: '5' },
        { label3: '6', value3: '6' },
        { label3: '7', value3: '7' },
    ]
}

export const FoodUsage = [
    { label: 'Empty Stomach', value: 'ES' },
    { label: 'Before Food', value: 'BF' },
    { label: 'with Food', value: 'WF' },
    { label: 'After Food', value: 'AF' },
    { label: 'External Use', value: 'EU' },
]

export const days = [
    { label: 'Days', value: 'days' },
    { label: 'Weeks', value: 'months' },
    { label: 'Months', value: 'months' },
    { label: 'Year', value: 'years' },
]


export const Doctor_Notes_Right_Layout_JSON = [
    { id: 1, field_name: 'patient_category', label: 'Patient Category', is_active: true },
    { id: 2, field_name: 'vitals', label: 'Vitals', is_active: true },
    { id: 3, field_name: 'allergy', label: 'Allergy', is_active: true },
    { id: 4, field_name: 'test', label: 'Test', is_active: true },
    { id: 5, field_name: 'counsellor', label: 'Counsellor', is_active: true },
]

export const Doctor_Notes_Left_Layout_JSON = [
    { id: 1, field_name: 'symptoms', label: 'Symptoms', is_active: true },
    { id: 2, field_name: 'examination', label: 'Examination', is_active: true },
    { id: 3, field_name: 'prescription', label: 'Prescription', is_active: true },
    { id: 4, field_name: 'diagnosis', label: 'Diagnosis', is_active: true },
    { id: 5, field_name: 'plan', label: 'Plan', is_active: true },
    { id: 6, field_name: 'general_advice', label: 'General Advice', is_active: true },
    { id: 7, field_name: 'optometry_notes', label: 'Optometrist Notes', is_active: true }
]

let isNewOtherDoc = JSON.parse(localStorage.getItem("loggedInUserInfo"))?.new_doctor_notes_template_others ? true : false

export const Other_Doctor_Notes_Layout_JSON = [
    { id: 1, field_name: 'symptoms', label: 'Symptoms', custom_name: 'Symptoms', is_active: true },
    { id: 2, field_name: 'patient_category', label: 'Patient Category', custom_name: 'Patient Category', is_active: true },
    { id: 3, field_name: 'allergies', label: 'Allergies', custom_name: 'Allergies', is_active: true },
    { id: 4, field_name: 'vitals', label: 'Vitals', custom_name: 'Vitals', is_active: true },
    { id: 5, field_name: 'examination', label: 'Examination', custom_name: 'Examination', is_active: true },
    { id: 6, field_name: 'diagnosis', label: 'Diagnosis', custom_name: 'Diagnosis', is_active: true },
    { id: 7, field_name: 'prescription', label: 'Prescription', custom_name: 'Prescription', is_active: true },
    { id: 8, field_name: 'test', label: 'Test', custom_name: 'Test', is_active: true },
    { id: 9, field_name: 'plan', label: 'Plan', custom_name: 'Plan', is_active: true },
    { id: 10, field_name: 'general_advice', label: 'General Advice', custom_name: 'General Advice', is_active: true },
    { id: 11, field_name: 'counselling', label: 'Counselling', custom_name: 'Counselling', is_active: true },
    { id: 12, field_name: 'review_plan', label: 'Review Plan', custom_name: 'Review Plan', is_active: true },
    { id: 13, field_name: 'Complaints', label: 'Complaints', custom_name: 'Complaints', is_active: true },
    { id: 14, field_name: 'clinical_history', label: 'Clinical History', custom_name: 'Clinical History', is_active: false },
    { id: 15, field_name: 'final_diagnosis', label: 'Final Diagnosis', custom_name: 'Final Diagnosis', is_active: false },
    { id: 16, field_name: 'pain_scale', label: 'Pain Scale', custom_name: 'Pain Scale', is_active: false },
    { id: 17, field_name: 'past_history', label: 'Past History', custom_name: 'Past History', is_active: false },
    { id: 18, field_name: 'history_of_presenting_illness', label: 'History of Presenting Illness', custom_name: 'History of Presenting Illness', is_active: false },
]

export const Doctor_Notes_OPT_Right_Layout_JSON = [
    { id: 1, field_name: 'Patient Category', label: 'Patient Category', is_active: true },
    { id: 2, field_name: 'complaints', label: 'Complaints', is_active: true },
    { id: 3, field_name: 'ocular_history', label: 'Ocular History', is_active: true },
    { id: 4, field_name: 'systemic_illness', label: 'Systemic Illness', is_active: true },
    { id: 5, field_name: 'vitals', label: 'Vitals', is_active: true },
    { id: 6, field_name: 'review_plan', label: 'Review Plan', is_active: true },
    { id: 7, field_name: 'investigations', label: 'Investigations', is_active: true },
    { id: 8, field_name: 'counsellor', label: 'Counsellor', is_active: true },
    { id: 9, field_name: 'schirmer_test', label: 'Schirmer Test', is_active: true },
]

export const Doctor_Notes_OPT_Left_Layout_JSON = [
    { id: 1, field_name: 'previous_glass_power', label: 'Previous Glass Power', is_active: true },
    { id: 2, field_name: 'subjective_refraction', label: 'Subjective Refraction', is_active: true },
    { id: 3, field_name: 'retinoscopic_refraction', label: 'Retinoscopic Refraction', is_active: true },
    { id: 20, field_name: 'retinoscopic_acceptance', label: 'Retinoscopic Acceptance', is_active: true },
    { id: 4, field_name: 'vision_assesment', label: 'Vision Assesment', is_active: true },
    { id: 5, field_name: 'ocular_response_analyzer', label: 'Ocular Response Analyzer', is_active: true },
    { id: 6, field_name: 'intraocular_pressure', label: 'Intraocular Pressure', is_active: true },
    { id: 7, field_name: 'auto_refractory', label: 'Auto Refractory', is_active: true },
    { id: 8, field_name: 'anterior_segment', label: 'Anterior Segment', is_active: true },
    { id: 9, field_name: 'anterior_segment_diagram', label: 'Anterior Segment Diagram', is_active: true },
    { id: 10, field_name: 'posterior_segment', label: 'Posterior Segment', is_active: true },
    { id: 11, field_name: 'other_investigation', label: 'Other Investigation', is_active: true },
    { id: 12, field_name: 'fundus', label: 'Fundus', is_active: true },
    { id: 13, field_name: 'keratomentry', label: 'Keratomentry', is_active: true },
    { id: 21, field_name: 'IOLMaster', label: 'IOLMaster', is_active: true },
    { id: 14, field_name: 'gonioscopy', label: 'Gonioscopy', is_active: true },
    { id: 15, field_name: 'diagnosis', label: 'Diagnosis', is_active: true },
    { id: 16, field_name: 'glass_prescription', label: 'Glass Prescription', is_active: true },
    { id: 17, field_name: 'prescription', label: 'Prescription', is_active: true },
    { id: 18, field_name: 'treatment_plan', label: 'Treatment Plan', is_active: true },
    { id: 19, field_name: 'notes', label: 'Notes', is_active: true },
    { id: 22, field_name: 'optometry_notes', label: 'Optometrist Notes', is_active: true },
    { id: 23, field_name: 'oct_findings', label: 'OCT Findings', is_active: true }
]

export const Doctor_Notes_OPTHOMETRY_Right_Layout_JSON = [
    { id: 1, field_name: 'Patient Category', label: 'Patient Category', is_active: true },
    { id: 2, field_name: 'complaints', label: 'Complaints', is_active: true },
    { id: 3, field_name: 'ocular_history', label: 'Ocular History', is_active: true },
    { id: 4, field_name: 'systemic_illness', label: 'Systemic Illness', is_active: true },
    { id: 5, field_name: 'vitals', label: 'Vitals', is_active: true },
    { id: 6, field_name: 'schirmer_test', label: 'Schirmer Test', is_active: true },
]

export const Doctor_Notes_OPTHOMETRY_Left_Layout_JSON = [
    { id: 1, field_name: 'previous_glass_power', label: 'Previous Glass Power', is_active: true },
    { id: 2, field_name: 'subjective_refraction', label: 'Subjective Refraction', is_active: true },
    { id: 3, field_name: 'retinoscopic_refraction', label: 'Retinoscopic Refraction', is_active: true },
    { id: 15, field_name: 'retinoscopic_acceptance', label: 'Retinoscopic Acceptance', is_active: true },
    { id: 4, field_name: 'vision_assesment', label: 'Vision Assesment', is_active: true },
    { id: 5, field_name: 'ocular_response_analyzer', label: 'Ocular Response Analyzer', is_active: true },
    { id: 6, field_name: 'intraocular_pressure', label: 'Intraocular Pressure', is_active: true },
    { id: 7, field_name: 'auto_refractory', label: 'Auto Refractory', is_active: true },
    { id: 8, field_name: 'anterior_segment', label: 'Anterior Segment', is_active: true },
    { id: 9, field_name: 'anterior_segment_diagram', label: 'Anterior Segment Diagram', is_active: true },
    { id: 10, field_name: 'posterior_segment', label: 'Posterior Segment', is_active: true },
    { id: 11, field_name: 'other_investigation', label: 'Other Investigation', is_active: true },
    { id: 12, field_name: 'keratomentry', label: 'Keratomentry', is_active: true },
    { id: 17, field_name: 'IOLMaster', label: 'IOLMaster', is_active: true },
    { id: 13, field_name: 'gonioscopy', label: 'Gonioscopy', is_active: true },
    { id: 14, field_name: 'notes', label: 'Notes', is_active: true },
    { id: 18, field_name: 'optometry_notes', label: 'Optometrist Notes', is_active: true },
    { id: 19, field_name: 'oct_findings', label: 'OCT Findings', is_active: true },
    { id: 16, field_name: 'glass_prescription', label: 'Glass Prescription', is_active: true },
]

export const DurationDays = [
    { label: 'Days', value: '1' },
    { label: 'Weeks', value: '2' },
    { label: 'Months', value: '3' },
    { label: 'Year', value: '4' },
]

export const UCVA_OPTIONS = [
    { value: '6/3', label: '6/3' },
    { value: '6/4', label: '6/4' },
    { value: '6/5', label: '6/5' },
    { value: '6/6', label: '6/6' },
    { value: '6/6P', label: '6/6P' },
    { value: '6/9', label: '6/9' },
    { value: '6/9P', label: '6/9P' },
    { value: '6/12', label: '6/12' },
    { value: '6/12P', label: '6/12P' },
    { value: '6/18', label: '6/18' },
    { value: '6/18P', label: '6/18P' },
    { value: '6/24', label: '6/24' },
    { value: '6/24P', label: '6/24P' },
    { value: '6/36', label: '6/36' },
    { value: '6/36P', label: '6/36P' },
    { value: '6/60', label: '6/60' },
    { value: '5/60', label: '5/60' },
    { value: '4/60', label: '4/60' },
    { value: 'CF 3', label: 'CF 3' },
    { value: 'CF 2', label: 'CF 2' },
    { value: 'CF 1', label: 'CF 1' },
    { value: 'CF 1/2', label: 'CF 1/2' },
    { value: 'CF CF', label: "CF CF" },
    { value: 'HM+', label: 'HM+' },
    { value: 'PL + PR Accurate', label: 'PL + PR Accurate' },
    { value: 'PL + PR Inaccurate', label: 'PL + PR Inaccurate' },
    { value: 'PL', label: 'PL' },
    { value: 'NPL', label: 'NPL' }
]

export const SPH_OPTIONS = [
    { "value": "0", "label": "0" }, { "value": "+0.25", "label": "+0.25" }, { "value": "+0.50", "label": "+0.50" }, { "value": "+0.75", "label": "+0.75" }, { "value": "+1.00", "label": "+1.00" }, { "value": "+1.25", "label": "+1.25" }, { "value": "+1.50", "label": "+1.50" }, { "value": "+1.75", "label": "+1.75" }, { "value": "+2.00", "label": "+2.00" }, { "value": "+2.25", "label": "+2.25" }, { "value": "+2.50", "label": "+2.50" }, { "value": "+2.75", "label": "+2.75" }, { "value": "+3.00", "label": "+3.00" }, { "value": "+3.25", "label": "+3.25" }, { "value": "+3.50", "label": "+3.50" }, { "value": "+3.75", "label": "+3.75" }, { "value": "+4.00", "label": "+4.00" }, { "value": "+4.25", "label": "+4.25" }, { "value": "+4.50", "label": "+4.50" }, { "value": "+4.75", "label": "+4.75" }, { "value": "+5.00", "label": "+5.00" }, { "value": "+5.25", "label": "+5.25" }, { "value": "+5.50", "label": "+5.50" }, { "value": "+5.75", "label": "+5.75" }, { "value": "+6.00", "label": "+6.00" }, { "value": "+6.25", "label": "+6.25" }, { "value": "+6.50", "label": "+6.50" }, { "value": "+6.75", "label": "+6.75" }, { "value": "+7.00", "label": "+7.00" }, { "value": "+7.25", "label": "+7.25" }, { "value": "+7.50", "label": "+7.50" }, { "value": "+7.75", "label": "+7.75" }, { "value": "+8.00", "label": "+8.00" }, { "value": "+8.25", "label": "+8.25" }, { "value": "+8.50", "label": "+8.50" }, { "value": "+8.75", "label": "+8.75" }, { "value": "+9.00", "label": "+9.00" }, { "value": "+9.25", "label": "+9.25" }, { "value": "+9.50", "label": "+9.50" }, { "value": "+9.75", "label": "+9.75" }, { "value": "+10.00", "label": "+10.00" }, { "value": "+10.25", "label": "+10.25" }, { "value": "+10.50", "label": "+10.50" }, { "value": "+10.75", "label": "+10.75" }, { "value": "+11.00", "label": "+11.00" }, { "value": "+11.25", "label": "+11.25" }, { "value": "+11.50", "label": "+11.50" }, { "value": "+11.75", "label": "+11.75" }, { "value": "+12.00", "label": "+12.00" }, { "value": "+12.25", "label": "+12.25" }, { "value": "+12.50", "label": "+12.50" }, { "value": "+12.75", "label": "+12.75" }, { "value": "+13.00", "label": "+13.00" }, { "value": "+13.25", "label": "+13.25" }, { "value": "+13.50", "label": "+13.50" }, { "value": "+13.75", "label": "+13.75" }, { "value": "+14.00", "label": "+14.00" }, { "value": "+14.25", "label": "+14.25" }, { "value": "+14.50", "label": "+14.50" }, { "value": "+14.75", "label": "+14.75" }, { "value": "+15.00", "label": "+15.00" }, { "value": "+15.25", "label": "+15.25" }, { "value": "+15.50", "label": "+15.50" }, { "value": "+15.75", "label": "+15.75" }, { "value": "+16.00", "label": "+16.00" }, { "value": "+16.25", "label": "+16.25" }, { "value": "+16.50", "label": "+16.50" }, { "value": "+16.75", "label": "+16.75" }, { "value": "+17.00", "label": "+17.00" }, { "value": "+17.25", "label": "+17.25" }, { "value": "+17.50", "label": "+17.50" }, { "value": "+17.75", "label": "+17.75" }, { "value": "+18.00", "label": "+18.00" }, { "value": "+18.25", "label": "+18.25" }, { "value": "+18.50", "label": "+18.50" }, { "value": "+18.75", "label": "+18.75" }, { "value": "+19.00", "label": "+19.00" }, { "value": "+19.25", "label": "+19.25" }, { "value": "+19.50", "label": "+19.50" }, { "value": "+19.75", "label": "+19.75" }, { "value": "+20.00", "label": "+20.00" }, { "value": "-0.25", "label": "-0.25" }, { "value": "-0.50", "label": "-0.50" }, { "value": "-0.75", "label": "-0.75" }, { "value": "-1.00", "label": "-1.00" }, { "value": "-1.25", "label": "-1.25" }, { "value": "-1.50", "label": "-1.50" }, { "value": "-1.75", "label": "-1.75" }, { "value": "-2.00", "label": "-2.00" }, { "value": "-2.25", "label": "-2.25" }, { "value": "-2.50", "label": "-2.50" }, { "value": "-2.75", "label": "-2.75" }, { "value": "-3.00", "label": "-3.00" }, { "value": "-3.25", "label": "-3.25" }, { "value": "-3.50", "label": "-3.50" }, { "value": "-3.75", "label": "-3.75" }, { "value": "-4.00", "label": "-4.00" }, { "value": "-4.25", "label": "-4.25" }, { "value": "-4.50", "label": "-4.50" }, { "value": "-4.75", "label": "-4.75" }, { "value": "-5.00", "label": "-5.00" }, { "value": "-5.25", "label": "-5.25" }, { "value": "-5.50", "label": "-5.50" }, { "value": "-5.75", "label": "-5.75" }, { "value": "-6.00", "label": "-6.00" }, { "value": "-6.25", "label": "-6.25" }, { "value": "-6.50", "label": "-6.50" }, { "value": "-6.75", "label": "-6.75" }, { "value": "-7.00", "label": "-7.00" }, { "value": "-7.25", "label": "-7.25" }, { "value": "-7.50", "label": "-7.50" }, { "value": "-7.75", "label": "-7.75" }, { "value": "-8.00", "label": "-8.00" }, { "value": "-8.25", "label": "-8.25" }, { "value": "-8.50", "label": "-8.50" }, { "value": "-8.75", "label": "-8.75" }, { "value": "-9.00", "label": "-9.00" }, { "value": "-9.25", "label": "-9.25" }, { "value": "-9.50", "label": "-9.50" }, { "value": "-9.75", "label": "-9.75" }, { "value": "-10.00", "label": "-10.00" }, { "value": "-10.25", "label": "-10.25" }, { "value": "-10.50", "label": "-10.50" }, { "value": "-10.75", "label": "-10.75" }, { "value": "-11.00", "label": "-11.00" }, { "value": "-11.25", "label": "-11.25" }, { "value": "-11.50", "label": "-11.50" }, { "value": "-11.75", "label": "-11.75" }, { "value": "-12.00", "label": "-12.00" }, { "value": "-12.25", "label": "-12.25" }, { "value": "-12.50", "label": "-12.50" }, { "value": "-12.75", "label": "-12.75" }, { "value": "-13.00", "label": "-13.00" }, { "value": "-13.25", "label": "-13.25" }, { "value": "-13.50", "label": "-13.50" }, { "value": "-13.75", "label": "-13.75" }, { "value": "-14.00", "label": "-14.00" }, { "value": "-14.25", "label": "-14.25" }, { "value": "-14.50", "label": "-14.50" }, { "value": "-14.75", "label": "-14.75" }, { "value": "-15.00", "label": "-15.00" }, { "value": "-15.25", "label": "-15.25" }, { "value": "-15.50", "label": "-15.50" }, { "value": "-15.75", "label": "-15.75" }, { "value": "-16.00", "label": "-16.00" }, { "value": "-16.25", "label": "-16.25" }, { "value": "-16.50", "label": "-16.50" }, { "value": "-16.75", "label": "-16.75" }, { "value": "-17.00", "label": "-17.00" }, { "value": "-17.25", "label": "-17.25" }, { "value": "-17.50", "label": "-17.50" }, { "value": "-17.75", "label": "-17.75" }, { "value": "-18.00", "label": "-18.00" }, { "value": "-18.25", "label": "-18.25" }, { "value": "-18.50", "label": "-18.50" }, { "value": "-18.75", "label": "-18.75" }, { "value": "-19.00", "label": "-19.00" }, { "value": "-19.25", "label": "-19.25" }, { "value": "-19.50", "label": "-19.50" }, { "value": "-19.75", "label": "-19.75" }, { "value": "-20.00", "label": "-20.00" }
];

export const NV_OPTIONS = [
    { "value": "0", "label": "0" }, { "value": "+0.25", "label": "+0.25" }, { "value": "+0.50", "label": "+0.50" }, { "value": "+0.75", "label": "+0.75" }, { "value": "+1.00", "label": "+1.00" }, { "value": "+1.25", "label": "+1.25" }, { "value": "+1.50", "label": "+1.50" }, { "value": "+1.75", "label": "+1.75" }, { "value": "+2.00", "label": "+2.00" }, { "value": "+2.25", "label": "+2.25" }, { "value": "+2.50", "label": "+2.50" }, { "value": "+2.75", "label": "+2.75" }, { "value": "+3.00", "label": "+3.00" }, { "value": "+3.25", "label": "+3.25" }, { "value": "+3.50", "label": "+3.50" }, { "value": "+3.75", "label": "+3.75" }, { "value": "+4.00", "label": "+4.00" }, { "value": "+4.25", "label": "+4.25" }, { "value": "+4.50", "label": "+4.50" }, { "value": "+4.75", "label": "+4.75" }, { "value": "+5.00", "label": "+5.00" }, { "value": "+5.25", "label": "+5.25" }, { "value": "+5.50", "label": "+5.50" }, { "value": "+5.75", "label": "+5.75" }, { "value": "+6.00", "label": "+6.00" }, { "value": "+6.25", "label": "+6.25" }, { "value": "+6.50", "label": "+6.50" }, { "value": "+6.75", "label": "+6.75" }, { "value": "+7.00", "label": "+7.00" }, { "value": "+7.25", "label": "+7.25" }, { "value": "+7.50", "label": "+7.50" }, { "value": "+7.75", "label": "+7.75" }, { "value": "+8.00", "label": "+8.00" }, { "value": "+8.25", "label": "+8.25" }, { "value": "+8.50", "label": "+8.50" }, { "value": "+8.75", "label": "+8.75" }, { "value": "+9.00", "label": "+9.00" }, { "value": "+9.25", "label": "+9.25" }, { "value": "+9.50", "label": "+9.50" }, { "value": "+9.75", "label": "+9.75" }, { "value": "+10.00", "label": "+10.00" }, { "value": "+10.25", "label": "+10.25" }, { "value": "+10.50", "label": "+10.50" }, { "value": "+10.75", "label": "+10.75" }, { "value": "+11.00", "label": "+11.00" }, { "value": "+11.25", "label": "+11.25" }, { "value": "+11.50", "label": "+11.50" }, { "value": "+11.75", "label": "+11.75" }, { "value": "+12.00", "label": "+12.00" }, { "value": "+12.25", "label": "+12.25" }, { "value": "+12.50", "label": "+12.50" }, { "value": "+12.75", "label": "+12.75" }, { "value": "+13.00", "label": "+13.00" }, { "value": "+13.25", "label": "+13.25" }, { "value": "+13.50", "label": "+13.50" }, { "value": "+13.75", "label": "+13.75" }, { "value": "+14.00", "label": "+14.00" }, { "value": "+14.25", "label": "+14.25" }, { "value": "+14.50", "label": "+14.50" }, { "value": "+14.75", "label": "+14.75" }, { "value": "+15.00", "label": "+15.00" }, { "value": "+15.25", "label": "+15.25" }, { "value": "+15.50", "label": "+15.50" }, { "value": "+15.75", "label": "+15.75" }, { "value": "+16.00", "label": "+16.00" }, { "value": "+16.25", "label": "+16.25" }, { "value": "+16.50", "label": "+16.50" }, { "value": "+16.75", "label": "+16.75" }, { "value": "+17.00", "label": "+17.00" }, { "value": "+17.25", "label": "+17.25" }, { "value": "+17.50", "label": "+17.50" }, { "value": "+17.75", "label": "+17.75" }, { "value": "+18.00", "label": "+18.00" }, { "value": "+18.25", "label": "+18.25" }, { "value": "+18.50", "label": "+18.50" }, { "value": "+18.75", "label": "+18.75" }, { "value": "+19.00", "label": "+19.00" }, { "value": "+19.25", "label": "+19.25" }, { "value": "+19.50", "label": "+19.50" }, { "value": "+19.75", "label": "+19.75" }, { "value": "+20.00", "label": "+20.00" }, { "value": "+20.25", "label": "+20.25" }, { "value": "+20.50", "label": "+20.50" }, { "value": "+20.75", "label": "+20.75" }, { "value": "+21.00", "label": "+21.00" }, { "value": "+21.25", "label": "+21.25" }, { "value": "+21.50", "label": "+21.50" }, { "value": "+21.75", "label": "+21.75" }, { "value": "+22.00", "label": "+22.00" }, { "value": "+22.25", "label": "+22.25" }, { "value": "+22.50", "label": "+22.50" }, { "value": "+22.75", "label": "+22.75" }, { "value": "+23.00", "label": "+23.00" }, { "value": "+23.25", "label": "+23.25" }, { "value": "+23.50", "label": "+23.50" }, { "value": "+23.75", "label": "+23.75" }, { "value": "+24.00", "label": "+24.00" }, { "value": "-0.25", "label": "-0.25" }, { "value": "-0.50", "label": "-0.50" }, { "value": "-0.75", "label": "-0.75" }, { "value": "-1.00", "label": "-1.00" }, { "value": "-1.25", "label": "-1.25" }, { "value": "-1.50", "label": "-1.50" }, { "value": "-1.75", "label": "-1.75" }, { "value": "-2.00", "label": "-2.00" }, { "value": "-2.25", "label": "-2.25" }, { "value": "-2.50", "label": "-2.50" }, { "value": "-2.75", "label": "-2.75" }, { "value": "-3.00", "label": "-3.00" }, { "value": "-3.25", "label": "-3.25" }, { "value": "-3.50", "label": "-3.50" }, { "value": "-3.75", "label": "-3.75" }, { "value": "-4.00", "label": "-4.00" }, { "value": "-4.25", "label": "-4.25" }, { "value": "-4.50", "label": "-4.50" }, { "value": "-4.75", "label": "-4.75" }, { "value": "-5.00", "label": "-5.00" }, { "value": "-5.25", "label": "-5.25" }, { "value": "-5.50", "label": "-5.50" }, { "value": "-5.75", "label": "-5.75" }, { "value": "-6.00", "label": "-6.00" }, { "value": "-6.25", "label": "-6.25" }, { "value": "-6.50", "label": "-6.50" }, { "value": "-6.75", "label": "-6.75" }, { "value": "-7.00", "label": "-7.00" }, { "value": "-7.25", "label": "-7.25" }, { "value": "-7.50", "label": "-7.50" }, { "value": "-7.75", "label": "-7.75" }, { "value": "-8.00", "label": "-8.00" }, { "value": "-8.25", "label": "-8.25" }, { "value": "-8.50", "label": "-8.50" }, { "value": "-8.75", "label": "-8.75" }, { "value": "-9.00", "label": "-9.00" }, { "value": "-9.25", "label": "-9.25" }, { "value": "-9.50", "label": "-9.50" }, { "value": "-9.75", "label": "-9.75" }, { "value": "-10.00", "label": "-10.00" }, { "value": "-10.25", "label": "-10.25" }, { "value": "-10.50", "label": "-10.50" }, { "value": "-10.75", "label": "-10.75" }, { "value": "-11.00", "label": "-11.00" }, { "value": "-11.25", "label": "-11.25" }, { "value": "-11.50", "label": "-11.50" }, { "value": "-11.75", "label": "-11.75" }, { "value": "-12.00", "label": "-12.00" }, { "value": "-12.25", "label": "-12.25" }, { "value": "-12.50", "label": "-12.50" }, { "value": "-12.75", "label": "-12.75" }, { "value": "-13.00", "label": "-13.00" }, { "value": "-13.25", "label": "-13.25" }, { "value": "-13.50", "label": "-13.50" }, { "value": "-13.75", "label": "-13.75" }, { "value": "-14.00", "label": "-14.00" }, { "value": "-14.25", "label": "-14.25" }, { "value": "-14.50", "label": "-14.50" }, { "value": "-14.75", "label": "-14.75" }, { "value": "-15.00", "label": "-15.00" }, { "value": "-15.25", "label": "-15.25" }, { "value": "-15.50", "label": "-15.50" }, { "value": "-15.75", "label": "-15.75" }, { "value": "-16.00", "label": "-16.00" }, { "value": "-16.25", "label": "-16.25" }, { "value": "-16.50", "label": "-16.50" }, { "value": "-16.75", "label": "-16.75" }, { "value": "-17.00", "label": "-17.00" }, { "value": "-17.25", "label": "-17.25" }, { "value": "-17.50", "label": "-17.50" }, { "value": "-17.75", "label": "-17.75" }, { "value": "-18.00", "label": "-18.00" }, { "value": "-18.25", "label": "-18.25" }, { "value": "-18.50", "label": "-18.50" }, { "value": "-18.75", "label": "-18.75" }, { "value": "-19.00", "label": "-19.00" }, { "value": "-19.25", "label": "-19.25" }, { "value": "-19.50", "label": "-19.50" }, { "value": "-19.75", "label": "-19.75" }, { "value": "-20.00", "label": "-20.00" }
];

export const FUNDUS_OPTION = [
    { "value": "0", "label": "0" },
    { "value": "1", "label": "1" },
    { "value": "2", "label": "2" },
    { "value": "3", "label": "3" },
    { "value": "4", "label": "4" },
    { "value": "5", "label": "5" },
    { "value": "6", "label": "6" },
    { "value": "7", "label": "7" },
    { "value": "8", "label": "8" },
    { "value": "9", "label": "9" },
    { "value": "10", "label": "10" }
];

export const CYL_OPTIONS = [
    { "value": "0", "label": "0" }, { "value": "+0.25", "label": "+0.25" }, { "value": "+0.50", "label": "+0.50" }, { "value": "+0.75", "label": "+0.75" }, { "value": "+1.00", "label": "+1.00" }, { "value": "+1.25", "label": "+1.25" }, { "value": "+1.50", "label": "+1.50" }, { "value": "+1.75", "label": "+1.75" }, { "value": "+2.00", "label": "+2.00" }, { "value": "+2.25", "label": "+2.25" }, { "value": "+2.50", "label": "+2.50" }, { "value": "+2.75", "label": "+2.75" }, { "value": "+3.00", "label": "+3.00" }, { "value": "+3.25", "label": "+3.25" }, { "value": "+3.50", "label": "+3.50" }, { "value": "+3.75", "label": "+3.75" }, { "value": "+4.00", "label": "+4.00" }, { "value": "+4.25", "label": "+4.25" }, { "value": "+4.50", "label": "+4.50" }, { "value": "+4.75", "label": "+4.75" }, { "value": "+5.00", "label": "+5.00" }, { "value": "+5.25", "label": "+5.25" }, { "value": "+5.50", "label": "+5.50" }, { "value": "+5.75", "label": "+5.75" }, { "value": "+6.00", "label": "+6.00" }, { "value": "+6.25", "label": "+6.25" }, { "value": "+6.50", "label": "+6.50" }, { "value": "+6.75", "label": "+6.75" }, { "value": "+7.00", "label": "+7.00" }, { "value": "+7.25", "label": "+7.25" }, { "value": "+7.50", "label": "+7.50" }, { "value": "+7.75", "label": "+7.75" }, { "value": "+8.00", "label": "+8.00" }, { "value": "+8.25", "label": "+8.25" }, { "value": "+8.50", "label": "+8.50" }, { "value": "+8.75", "label": "+8.75" }, { "value": "+9.00", "label": "+9.00" }, { "value": "+9.25", "label": "+9.25" }, { "value": "+9.50", "label": "+9.50" }, { "value": "+9.75", "label": "+9.75" }, { "value": "+10.00", "label": "+10.00" }, { "value": "+10.25", "label": "+10.25" }, { "value": "+10.50", "label": "+10.50" }, { "value": "+10.75", "label": "+10.75" }, { "value": "+11.00", "label": "+11.00" }, { "value": "+11.25", "label": "+11.25" }, { "value": "+11.50", "label": "+11.50" }, { "value": "+11.75", "label": "+11.75" }, { "value": "+12.00", "label": "+12.00" }, { "value": "+12.25", "label": "+12.25" }, { "value": "+12.50", "label": "+12.50" }, { "value": "+12.75", "label": "+12.75" }, { "value": "+13.00", "label": "+13.00" }, { "value": "+13.25", "label": "+13.25" }, { "value": "+13.50", "label": "+13.50" }, { "value": "+13.75", "label": "+13.75" }, { "value": "+14.00", "label": "+14.00" }, { "value": "+14.25", "label": "+14.25" }, { "value": "+14.50", "label": "+14.50" }, { "value": "+14.75", "label": "+14.75" }, { "value": "+15.00", "label": "+15.00" }, { "value": "+15.25", "label": "+15.25" }, { "value": "+15.50", "label": "+15.50" }, { "value": "+15.75", "label": "+15.75" }, { "value": "+16.00", "label": "+16.00" }, { "value": "+16.25", "label": "+16.25" }, { "value": "+16.50", "label": "+16.50" }, { "value": "+16.75", "label": "+16.75" }, { "value": "+17.00", "label": "+17.00" }, { "value": "+17.25", "label": "+17.25" }, { "value": "+17.50", "label": "+17.50" }, { "value": "+17.75", "label": "+17.75" }, { "value": "+18.00", "label": "+18.00" }, { "value": "+18.25", "label": "+18.25" }, { "value": "+18.50", "label": "+18.50" }, { "value": "+18.75", "label": "+18.75" }, { "value": "+19.00", "label": "+19.00" }, { "value": "+19.25", "label": "+19.25" }, { "value": "+19.50", "label": "+19.50" }, { "value": "+19.75", "label": "+19.75" }, { "value": "+20.00", "label": "+20.00" }, { "value": "-0.25", "label": "-0.25" }, { "value": "-0.50", "label": "-0.50" }, { "value": "-0.75", "label": "-0.75" }, { "value": "-1.00", "label": "-1.00" }, { "value": "-1.25", "label": "-1.25" }, { "value": "-1.50", "label": "-1.50" }, { "value": "-1.75", "label": "-1.75" }, { "value": "-2.00", "label": "-2.00" }, { "value": "-2.25", "label": "-2.25" }, { "value": "-2.50", "label": "-2.50" }, { "value": "-2.75", "label": "-2.75" }, { "value": "-3.00", "label": "-3.00" }, { "value": "-3.25", "label": "-3.25" }, { "value": "-3.50", "label": "-3.50" }, { "value": "-3.75", "label": "-3.75" }, { "value": "-4.00", "label": "-4.00" }, { "value": "-4.25", "label": "-4.25" }, { "value": "-4.50", "label": "-4.50" }, { "value": "-4.75", "label": "-4.75" }, { "value": "-5.00", "label": "-5.00" }, { "value": "-5.25", "label": "-5.25" }, { "value": "-5.50", "label": "-5.50" }, { "value": "-5.75", "label": "-5.75" }, { "value": "-6.00", "label": "-6.00" }, { "value": "-6.25", "label": "-6.25" }, { "value": "-6.50", "label": "-6.50" }, { "value": "-6.75", "label": "-6.75" }, { "value": "-7.00", "label": "-7.00" }, { "value": "-7.25", "label": "-7.25" }, { "value": "-7.50", "label": "-7.50" }, { "value": "-7.75", "label": "-7.75" }, { "value": "-8.00", "label": "-8.00" }, { "value": "-8.25", "label": "-8.25" }, { "value": "-8.50", "label": "-8.50" }, { "value": "-8.75", "label": "-8.75" }, { "value": "-9.00", "label": "-9.00" }, { "value": "-9.25", "label": "-9.25" }, { "value": "-9.50", "label": "-9.50" }, { "value": "-9.75", "label": "-9.75" }, { "value": "-10.00", "label": "-10.00" }, { "value": "-10.25", "label": "-10.25" }, { "value": "-10.50", "label": "-10.50" }, { "value": "-10.75", "label": "-10.75" }, { "value": "-11.00", "label": "-11.00" }, { "value": "-11.25", "label": "-11.25" }, { "value": "-11.50", "label": "-11.50" }, { "value": "-11.75", "label": "-11.75" }, { "value": "-12.00", "label": "-12.00" }, { "value": "-12.25", "label": "-12.25" }, { "value": "-12.50", "label": "-12.50" }, { "value": "-12.75", "label": "-12.75" }, { "value": "-13.00", "label": "-13.00" }, { "value": "-13.25", "label": "-13.25" }, { "value": "-13.50", "label": "-13.50" }, { "value": "-13.75", "label": "-13.75" }, { "value": "-14.00", "label": "-14.00" }, { "value": "-14.25", "label": "-14.25" }, { "value": "-14.50", "label": "-14.50" }, { "value": "-14.75", "label": "-14.75" }, { "value": "-15.00", "label": "-15.00" }, { "value": "-15.25", "label": "-15.25" }, { "value": "-15.50", "label": "-15.50" }, { "value": "-15.75", "label": "-15.75" }, { "value": "-16.00", "label": "-16.00" }, { "value": "-16.25", "label": "-16.25" }, { "value": "-16.50", "label": "-16.50" }, { "value": "-16.75", "label": "-16.75" }, { "value": "-17.00", "label": "-17.00" }, { "value": "-17.25", "label": "-17.25" }, { "value": "-17.50", "label": "-17.50" }, { "value": "-17.75", "label": "-17.75" }, { "value": "-18.00", "label": "-18.00" }, { "value": "-18.25", "label": "-18.25" }, { "value": "-18.50", "label": "-18.50" }, { "value": "-18.75", "label": "-18.75" }, { "value": "-19.00", "label": "-19.00" }, { "value": "-19.25", "label": "-19.25" }, { "value": "-19.50", "label": "-19.50" }, { "value": "-19.75", "label": "-19.75" }, { "value": "-20.00", "label": "-20.00" }
];

export const DIOPTER_OPTIONS = [
    { "value": "36.00", "label": "36.00" },
    { "value": "36.25", "label": "36.25" },
    { "value": "36.50", "label": "36.50" },
    { "value": "36.75", "label": "36.75" },
    { "value": "37.00", "label": "37.00" },
    { "value": "37.25", "label": "37.25" },
    { "value": "37.50", "label": "37.50" },
    { "value": "37.75", "label": "37.75" },
    { "value": "38.00", "label": "38.00" },
    { "value": "38.25", "label": "38.25" },
    { "value": "38.50", "label": "38.50" },
    { "value": "38.75", "label": "38.75" },
    { "value": "39.00", "label": "39.00" },
    { "value": "39.25", "label": "39.25" },
    { "value": "39.50", "label": "39.50" },
    { "value": "39.75", "label": "39.75" },
    { "value": "40.00", "label": "40.00" },
    { "value": "40.25", "label": "40.25" },
    { "value": "40.50", "label": "40.50" },
    { "value": "40.75", "label": "40.75" },
    { "value": "41.00", "label": "41.00" },
    { "value": "41.25", "label": "41.25" },
    { "value": "41.50", "label": "41.50" },
    { "value": "41.75", "label": "41.75" },
    { "value": "42.00", "label": "42.00" },
    { "value": "42.25", "label": "42.25" },
    { "value": "42.50", "label": "42.50" },
    { "value": "42.75", "label": "42.75" },
    { "value": "43.00", "label": "43.00" },
    { "value": "43.25", "label": "43.25" },
    { "value": "43.50", "label": "43.50" },
    { "value": "43.75", "label": "43.75" },
    { "value": "44.00", "label": "44.00" },
    { "value": "44.25", "label": "44.25" },
    { "value": "44.50", "label": "44.50" },
    { "value": "44.75", "label": "44.75" },
    { "value": "45.00", "label": "45.00" },
    { "value": "45.25", "label": "45.25" },
    { "value": "45.50", "label": "45.50" },
    { "value": "45.75", "label": "45.75" },
    { "value": "46.00", "label": "46.00" },
];

export const MM_OPTIONS = [
    { "value": "9.97", "label": "9.97" },
    { "value": "9.31", "label": "9.31" },
    { "value": "9.24", "label": "9.24" },
    { "value": "9.18", "label": "9.18" },
    { "value": "9.12", "label": "9.12" },
    { "value": "9.06", "label": "9.06" },
    { "value": "9.00", "label": "9.00" },
    { "value": "8.94", "label": "8.94" },
    { "value": "8.88", "label": "8.88" },
    { "value": "8.82", "label": "8.82" },
    { "value": "8.76", "label": "8.76" },
    { "value": "8.70", "label": "8.70" },
    { "value": "8.65", "label": "8.65" },
    { "value": "8.60", "label": "8.60" },
    { "value": "8.54", "label": "8.54" },
    { "value": "8.49", "label": "8.49" },
    { "value": "8.44", "label": "8.44" },
    { "value": "8.39", "label": "8.39" },
    { "value": "8.33", "label": "8.33" },
    { "value": "8.28", "label": "8.28" },
    { "value": "8.23", "label": "8.23" },
    { "value": "8.18", "label": "8.18" },
    { "value": "8.13", "label": "8.13" },
    { "value": "8.08", "label": "8.08" },
    { "value": "8.04", "label": "8.04" },
    { "value": "7.99", "label": "7.99" },
    { "value": "7.94", "label": "7.94" },
    { "value": "7.89", "label": "7.89" },
    { "value": "7.85", "label": "7.85" },
    { "value": "7.80", "label": "7.80" },
    { "value": "7.76", "label": "7.76" },
    { "value": "7.71", "label": "7.71" },
    { "value": "7.67", "label": "7.67" },
    { "value": "7.63", "label": "7.63" },
    { "value": "7.58", "label": "7.58" },
    { "value": "7.54", "label": "7.54" },
    { "value": "7.50", "label": "7.50" },
    { "value": "7.46", "label": "7.46" },
    { "value": "7.42", "label": "7.42" },
    { "value": "7.38", "label": "7.38" },
    { "value": "7.34", "label": "7.34" },
];

export const CYLINDRICAL_OPTIONS = [
    { "value": "40.00", "label": "40.00" },
    { "value": "40.25", "label": "40.25" },
    { "value": "40.50", "label": "40.50" },
    { "value": "40.75", "label": "40.75" },
    { "value": "41.00", "label": "41.00" },
    { "value": "41.25", "label": "41.25" },
    { "value": "41.50", "label": "41.50" },
    { "value": "41.75", "label": "41.75" },
    { "value": "42.00", "label": "42.00" },
    { "value": "42.25", "label": "42.25" },
    { "value": "42.50", "label": "42.50" },
    { "value": "42.75", "label": "42.75" },
    { "value": "43.00", "label": "43.00" },
    { "value": "43.25", "label": "43.25" },
    { "value": "43.50", "label": "43.50" },
    { "value": "43.75", "label": "43.75" },
    { "value": "44.00", "label": "44.00" },
    { "value": "44.25", "label": "44.25" },
    { "value": "44.50", "label": "44.50" },
    { "value": "44.75", "label": "44.75" },
    { "value": "45.00", "label": "45.00" },
    { "value": "-40.00", "label": "-40.00" },
    { "value": "-40.25", "label": "-40.25" },
    { "value": "-40.50", "label": "-40.50" },
    { "value": "-40.75", "label": "-40.75" },
    { "value": "-41.00", "label": "-41.00" },
    { "value": "-41.25", "label": "-41.25" },
    { "value": "-41.50", "label": "-41.50" },
    { "value": "-41.75", "label": "-41.75" },
    { "value": "-42.00", "label": "-42.00" },
    { "value": "-42.25", "label": "-42.25" },
    { "value": "-42.50", "label": "-42.50" },
    { "value": "-42.75", "label": "-42.75" },
    { "value": "-43.00", "label": "-43.00" },
    { "value": "-43.25", "label": "-43.25" },
    { "value": "-43.50", "label": "-43.50" },
    { "value": "-43.75", "label": "-43.75" },
    { "value": "-44.00", "label": "-44.00" },
    { "value": "-44.25", "label": "-44.25" },
    { "value": "-44.50", "label": "-44.50" },
    { "value": "-44.75", "label": "-44.75" },
    { "value": "-45.00", "label": "-45.00" },
    { "value": "-45.25", "label": "-45.25" },
    { "value": "-45.50", "label": "-45.50" },
    { "value": "-45.75", "label": "-45.75" },
    { "value": "-46.00", "label": "-46.00" },
];

export const DEFAULT_OCCUPATIONS_SR = [
    { value: "Professional", label: "Professional" },
    { value: "Goldsmith", label: "Goldsmith" },
    { value: "Farmer", label: "Farmer" },
    { value: "Self-employed", label: "Self-employed" },
    { value: "Businessman", label: "Businessman" },
    { value: "Tailor", label: "Tailor" },
    { value: "Student", label: "Student" },
    { value: "Others", label: "Others" },
];
export const DEFAULT_CHARTUSED_SR = [
    { value: "SNELLEN", label: "SNELLEN" },
    { value: "TUMBLING E", label: "TUMBLING E" },
    { value: "LANDOLT C", label: "LANDOLT C" },
    { value: "ETDRS", label: "ETDRS" },
    { value: "SINGLE NUMBER", label: "SINGLE NUMBER" }
];
export const DEFAULT_MUSCLES_SR = [
    { value: "Ciliary", label: "Ciliary" },
    { value: "Ocular", label: "Ocular" },
    { value: "Extra-Ocular", label: "Extra-Ocular" },
];

export const DEFAULT_LENS_TYPE = [
    { value: "Disposable Soft", label: "Disposable Soft" },
    { value: "Daily", label: "Daily" },
    { value: "Extended Wear", label: "Extended Wear" },
    { value: "Spherical", label: "Spherical" },
    { value: "Toric", label: "Toric" },
    { value: "Monovision", label: "Monovision" },
    { value: "Multifocal / Bifocal", label: "Multifocal / Bifocal" },
    { value: "Conventional", label: "Conventional" },
    { value: "Rigid Gas Permeable", label: "Rigid Gas Permeable" },
    { value: "Hard", label: "Hard" },

];

export const AXIS_OPTIONS = [
    { value: "0", label: "0" },
    { value: "5", label: "5" },
    { value: "10", label: "10" },
    { value: "15", label: "15" },
    { value: "20", label: "20" },
    { value: "25", label: "25" },
    { value: "30", label: "30" },
    { value: "35", label: "35" },
    { value: "40", label: "40" },
    { value: "45", label: "45" },
    { value: "50", label: "50" },
    { value: "55", label: "55" },
    { value: "60", label: "60" },
    { value: "65", label: "65" },
    { value: "70", label: "70" },
    { value: "75", label: "75" },
    { value: "80", label: "80" },
    { value: "85", label: "85" },
    { value: "90", label: "90" },
    { value: "95", label: "95" },
    { value: "100", label: "100" },
    { value: "105", label: "105" },
    { value: "110", label: "110" },
    { value: "115", label: "115" },
    { value: "120", label: "120" },
    { value: "125", label: "125" },
    { value: "130", label: "130" },
    { value: "135", label: "135" },
    { value: "140", label: "140" },
    { value: "145", label: "145" },
    { value: "150", label: "150" },
    { value: "155", label: "155" },
    { value: "160", label: "160" },
    { value: "165", label: "165" },
    { value: "170", label: "170" },
    { value: "175", label: "175" },
    { value: "180", label: "180" },
];

export const ADD = [
    { "label": "0", "value": "0" },
    { "label": "+0.25", "value": "+0.25" },
    { "label": "+0.50", "value": "+0.50" },
    { "label": "+0.75", "value": "+0.75" },
    { "label": "+1.00", "value": "+1.00" },
    { "label": "+1.25", "value": "+1.25" },
    { "label": "+1.50", "value": "+1.50" },
    { "label": "+1.75", "value": "+1.75" },
    { "label": "+2.00", "value": "+2.00" },
    { "label": "+2.25", "value": "+2.25" },
    { "label": "+2.50", "value": "+2.50" },
    { "label": "+2.75", "value": "+2.75" },
    { "label": "+3.00", "value": "+3.00" },
    { "label": "+3.25", "value": "+3.25" },
    { "label": "+3.50", "value": "+3.50" },
    { "label": "+3.75", "value": "+3.75" },
    { "label": "+4.00", "value": "+4.00" },
];

export const BCDVA_OPTIONS = [
    { value: '6/3', label: '6/3' },
    { value: '6/4', label: '6/4' },
    { value: '6/5', label: '6/5' },
    { value: '6/6', label: '6/6' },
    { value: '6/6p', label: '6/6p' },
    { value: '6/9', label: '6/9' },
    { value: '6/9p', label: '6/9p' },
    { value: '6/12', label: '6/12' },
    { value: '6/12p', label: '6/12p' },
    { value: '6/18', label: '6/18' },
    { value: '6/18p', label: '6/18p' },
    { value: '6/24', label: '6/24' },
    { value: '6/24p', label: '6/24p' },
    { value: '6/36', label: '6/36' },
    { value: '6/60', label: '6/60' },
    { value: '5/60', label: '5/60' },
    { value: '4/60', label: '4/60' },
    { value: 'CF 3', label: 'CF 3' },
    { value: 'CF 2', label: 'CF 2' },
    { value: 'CF 1', label: 'CF 1' },
    { value: 'CF 1/2', label: 'CF 1/2' },
    { value: 'CF CF', label: "CF CF" },
    { value: 'HM+', label: 'HM+' },
    { value: 'PL + PR Accurate', label: 'PL + PR Accurate' },
    { value: 'PL + PR Inaccurate', label: 'PL + PR Inaccurate' },
    { value: 'PL', label: 'PL' },
    { value: 'NPL', label: 'NPL' },
    { value: 'NI', label: 'NI' },
];

export const UCNVA_OPTIONS = [
    ...((JSON.parse(localGetItem('loggedInUserInfo'))?.new_doctor_notes_template === true) ? [{ "label": "N5", "value": "N5" }] : []),
    { "label": "N6", "value": "N6" },
    { "label": "N8", "value": "N8" },
    { "label": "N10", "value": "N10" },
    { "label": "N12", "value": "N12" },
    { "label": "N24", "value": "N24" },
    { "label": "N36", "value": "N36" },
];

export const BCNVA = [
    ...((JSON.parse(localGetItem('loggedInUserInfo'))?.new_doctor_notes_template === true) ? [{ "label": "N5", "value": "N5" }] : []),
    { "label": "N6", "value": "N6" },
    { "label": "N8", "value": "N8" },
    { "label": "N10", "value": "N10" },
    { "label": "N12", "value": "N12" },
    { "label": "N18", "value": "N18" },
    { "label": "N24", "value": "N24" },
    { "label": "N36", "value": "N36" },
    { "label": "NPL", "value": "NPL" },
    { "label": "NI", "value": "NI" },
];

export const PRISM_OPTIONS = [
    { value: '0', label: '0' },
    { value: '+0.25', label: '+0.25' },
    { value: '+0.5', label: '+0.5' },
    { value: '+0.75', label: '+0.75' },
    { value: '+1.00', label: '+1.00' },
    { value: '+1.25', label: '+1.25' },
    { value: '+1.5', label: '+1.5' },
    { value: '+1.75', label: '+1.75' },
    { value: '-0.25', label: '-0.25' },
    { value: '-0.5', label: '-0.5' },
    { value: '-0.75', label: '-0.75' },
    { value: '-1.00', label: '-1.00' },
    { value: '-1.25', label: '-1.25' },
    { value: '-1.5', label: '-1.5' },
    { value: '-1.75', label: '-1.75' },
    { value: '-2.00', label: '-2.00' },
];

export const VISION_OPTION = [
    { value: '0', label: '0' },
    { value: '+HM', label: "+HM" },
    { value: '+CFCF', label: "+CFCF" },
    { value: '+CF 1/2', label: '+CF 1/2' },
    { value: '+CF 1', label: '+CF 1' },
    { value: '+CF 2', label: '+CF 2' },
    { value: '+CF 3', label: '+CF 3' },
    { value: '+6/60', label: '+6/60' },
    { value: '+6/36', label: '+6/36' },
    { value: '+6/24', label: '+6/24' },
    { value: '+6/18', label: '+6/18' },
    { value: '+6/12', label: '+6/12' },
];

export const BASE_OPTION = [
    { value: 'BD', label: "BD" },
    { value: 'BU', label: "BU" },
    { value: 'BI', label: "BI" },
    { value: 'BO', label: "BO" },
];

export const PHVA_OPTION = [
    { value: '6/3', label: '6/3' },
    { value: '6/4', label: '6/4' },
    { value: '6/5', label: '6/5' },
    { value: '6/6', label: '6/6' },
    { value: '6/6p', label: '6/6p' },
    { value: '6/9', label: '6/9' },
    { value: '6/9p', label: '6/9p' },
    { value: '6/12', label: '6/12' },
    { value: '6/12p', label: '6/12p' },
    { value: '6/18', label: '6/18' },
    { value: '6/18p', label: '6/18p' },
    { value: '6/24', label: '6/24' },
    { value: '6/24p', label: '6/24p' },
    { value: '6/36', label: '6/36' },
    { value: '4/60', label: '4/60' },
    { value: '5/60', label: '5/60' },
    { value: '6/60', label: '6/60' },
    { value: 'CF 3', label: 'CF 3' },
    { value: 'CF 2', label: 'CF 2' },
    { value: 'CF 1', label: 'CF 1' },
    { value: 'CF 1/2', label: 'CF 1/2' },
    { value: 'CF CF', label: "CF CF" },
    { value: 'HM+', label: 'HM+' },
    { value: 'PL + PR Accurate', label: 'PL + PR Accurate' },
    { value: 'PL + PR Inaccurate', label: 'PL + PR Inaccurate' },
    { value: 'PL', label: 'PL' },
    { value: 'NPL', label: 'NPL' },
    { value: 'NI', label: 'NI' }
];

export const DEFAULT_DRUGS_IN_SYSTEMIC_ILLNESS = [
    ["Diabetes", "Asthma", "Hypertension", "Hypo Thyroid", "Hyper Thyroid", "Liver Disease", "Chronic Renal Failure"]
];
export const DEFAULT_DRUGS_IN_DRUGALLERGY = [
    { 0: "Drosyn" },
    { 1: "Salpha" },
    { 2: "Penicillin" },
    { 3: "Aspirin" },
    { 4: "Tetracycline" },
    { 5: "Cipro Floxin" }
];

export const NV_TYPE_OPTIONS = [
    { value: '0', label: '0' },
    ...((JSON.parse(localGetItem('loggedInUserInfo'))?.new_doctor_notes_template === true) ? [{ "label": "N5", "value": "N5" }] : []),
    { value: 'N6', label: 'N6' },
    { value: 'N8', label: 'N8' },
    { value: 'N10', label: 'N10' },
    { value: 'N12', label: 'N12' },
    { value: 'N18', label: 'N18' },
    { value: 'N24', label: 'N24' },
    { value: 'N36', label: 'N36' },
    { value: '<36', label: '<36' },
    { value: 'NI', label: 'NI' }
];

export const CV_OPTIONS = [
    { value: 'Red', label: 'Red' },
    { value: 'Green', label: 'Green' },
    { value: 'Blue', label: 'Blue' },
    { value: 'Red & Green', label: 'Red & Green' },
    { value: 'Blue & Red', label: 'Blue & Red' },
    { value: 'Green & Blue', label: 'Green & Blue' },
    { value: 'Normal', label: 'Normal' }
];

export const LENS_TYPE_OPTIONS = [
    { value: 'SINGLE VISION', label: 'Single Vision' },
    { value: 'BIFOCAL', label: 'Bifocal' },
    { value: 'PROGRESSIVE', label: 'Progressive' },
    { value: 'GLASS', label: 'Glass' },
    { value: 'K-BIFOCAL', label: 'K-Bifocal' },
    { value: 'CR-39', label: 'CR-39' },
    { value: 'D-BIFOCAL', label: 'D-Bifocal' },
    { value: 'POLARISED', label: 'Polarised' },
    { value: 'POLT CARBONATE', label: 'Polycarbonate' },
    { value: 'EXECUTIVE', label: 'Executive' },
    { value: 'CONTACT LENS', label: 'Contact Lens' },
    { value: 'READING GLASS', label: 'Reading Glass' },
];

export const FundusImage = "data:image/jpeg;base64,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"

export const AnteriorImage = "data:image/jpeg;base64,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"

export const ClinicalExamImage = 'data:image/svg+xml;base64,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'
export const LENS_COATING_OPTIONS = ['ARC', 'HIGH INDEX', 'PHOTOCHROMIC', 'ASPHERIC', 'UV PROTECTION', 'BLUE BLOCK',];

// export const Bucket_Name = 'emedhub-stage'
export const Bucket_Name = 'emedhub'

export const CurrencySymbol = JSON.parse(localStorage.getItem("loggedInUserInfo"))?.currency_symbol ? JSON.parse(localStorage.getItem("loggedInUserInfo")).currency_symbol : '₹'

export const Made_Of_Delivery = [
    { label: "Normal", value: 1 },
    { label: "C-Section", value: 2 },
    { label: "Assisted", value: 3 }
]

export const Gestational_Age = [
    { label: "Pre-Term", value: 1 },
    { label: "Full-Term", value: 2 },
    { label: "Post-Term", value: 3 }
]

export const Birth_Weight = [
    { label: "2kg", value: 2 },
    { label: "2.5kg", value: 2.5 },
    { label: "3kg", value: 3 },
    { label: "3.5kg", value: 3.5 }
]

export const Medical_Problems = [
    { label: "Obesity", value: "Obesity" },
    { label: "Acid Reflux (GERD)", value: "Acid Reflux (GERD)" },
    { label: "Acne", value: "Acne" },
    { label: "BedWetting", value: "BedWetting" },
    { label: "Growth Problems", value: "Growth Problems" },
    { label: "Developmental Issues", value: "Developmental Issues" },
    { label: "School Performance", value: "School Performance" },
    { label: "Eczema", value: "Eczema" },
    { label: "Headaches", value: "Headaches" },
    { label: "Depression", value: "Depression" },
    { label: "Attension Issues", value: "Attension Issues" },
    { label: "Ear Infections", value: "Ear Infections" },
    { label: "Constipation", value: "Constipation" },
    { label: "Serious Illness", value: "Serious Illness" },
    { label: "Immunization / Infections Disease", value: "Immunization / Infections Disease" },
]

export const Growth_chart = [
    { label: "Height", value: "height" },
    { label: "Weight", value: "weight" },
    { label: "BMI", value: "bmi" },
    { label: "Head Circumference", value: 'head circumference' }
]

export const Ages = [
    { label: "2 Months", value: "2 Months" },
    { label: "4 Months", value: "4 Months" },
    { label: "6 Months", value: "6 Months" },
    { label: "9 Months", value: "9 Months" },
    { label: "12 Months", value: "12 Months" },
    { label: "15 Months", value: "15 Months" },
    { label: "16-18 Months", value: "16-18 Months" },
    { label: "18-24 Months", value: "18-24 Months" },
    { label: "2-3 Years", value: "2-3 Years" },
    { label: "3-4 Years", value: "3-4 Years" },
    { label: "4-5 Years", value: "4-5 Years" },
]
export const Medication_dosages = [
    { value: 'CAPSULE', label: "Capsule", change_count: 0 },
    { value: 'DROP', label: "Drop", change_count: 0 },
    { value: 'DT', label: 'DT', change_count: 0 },
    { value: 'INJECTION', label: 'Injection', change_count: 0 },
    { value: 'LOTION', label: 'Lotion', change_count: 0 },
    { value: 'OINTMENT', label: 'Ointment', change_count: 0 },
    { value: 'SOLUTION', label: "Solution", change_count: 0 },
    { value: 'SYRUP', label: "Syrup", change_count: 0 },
    { value: 'TABLET', label: "Tablet", change_count: 0 },
    { value: 'OTHERS', label: "Others", change_count: 0 }
];

export const DischargeTypeList = ["Normal", "AMA", "Referral Out", "At Request", "Deceased", "Day Care"]

export const Asset_Type = [
    { name: "Movable", value: "Movable" },
    { name: "Fixed", value: "Fixed" }
]

export const Asset_Condition = [
    { name: "Working", value: "Working" },
    { name: "Idle", value: "Idle" },
    { name: "Not Working", value: "Not Working" }
]

export const Asset_Status = [
    { name: "Online", value: "Online" },
    { name: "Offline", value: "Offline" }
]

export const Priority_List = [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
]

export const Complaint_Type_List = [
    { label: 'Reactive', value: 'Reactive' },
    { label: 'Proactive', value: 'Proactive' },
    { label: 'General', value: 'General' },
]

export const Complaint_Status = ['Registered', 'Work Initiated', 'Work In Progress', 'Complaint Resolved', 'Work Done']

export const Warranty_Status = ['Valid', 'Expired']

export const DOC_PRINT_DEFAULT = {
    other_doctor: [
        { is_checked: false, label: 'Full Report', system_name: 'Full Report', value: 'FullReport', print_order: 0 },
        { is_checked: true, label: 'Symptoms', system_name: 'Symptoms', value: 'Symptoms', print_order: 1 },
        { is_checked: false, label: 'Allergies', system_name: 'Allergies', value: 'Allergies', print_order: 2 },
        { is_checked: false, label: 'Vitals', system_name: 'Vitals', value: 'Vitals', print_order: 3 },
        { is_checked: false, label: 'Examination', system_name: 'Examination', value: 'Examination', print_order: 4 },
        { is_checked: true, label: 'Diagnosis', system_name: 'Diagnosis', value: 'Diagnosis', print_order: 5 },
        { is_checked: true, label: 'Prescription', system_name: 'Prescription', value: 'Prescription', print_order: 6 },
        { is_checked: false, label: 'Previous Prescription', system_name: 'Previous Prescription', value: 'PreviousPrescription', print_order: 7 },
        { is_checked: false, label: 'Test', system_name: 'Test', value: 'Test', print_order: 8 },
        { is_checked: false, label: 'Plan', system_name: 'Plan', value: 'Plan', print_order: 9 },
        { is_checked: true, label: 'General Advice', system_name: 'General Advice', value: 'GeneralPatientAdvice', print_order: 10 },
        ...(isNewOtherDoc ? [] : [{ is_checked: true, label: 'Counselling', system_name: 'Counselling', value: 'Conselling', print_order: 11 }]),
        { is_checked: true, label: 'Review Plan', system_name: 'Review Plan', value: 'ReviewPlan', print_order: isNewOtherDoc ? 11 : 12 },
        { is_checked: true, label: 'Complaints', system_name: 'Complaints', value: 'Complaints', print_order: isNewOtherDoc ? 12 : 13 },
        ...(isNewOtherDoc ? [] : [{ is_checked: false, label: 'Clinical History', system_name: 'Clinical History', value: 'ClinicalHistory', print_order: 14 }]),
        { is_checked: true, label: 'Final Diagnosis', system_name: 'Final Diagnosis', value: 'FinalDiagnosis', print_order: isNewOtherDoc ? 13 : 15 },
        { is_checked: false, label: 'Pain Scale', system_name: 'Pain Scale', value: 'PainScale', print_order: isNewOtherDoc ? 14 : 16 },
        ...(isNewOtherDoc ? [] : [{ is_checked: false, label: 'Past History', system_name: 'Past History', value: 'PastHistory', print_order: isNewOtherDoc ? 15 : 17 }]),
        ...(isNewOtherDoc ? [] : [{ is_checked: false, label: 'History of Presenting Illness', system_name: 'History of Presenting Illness', value: 'HistoryofPresentingIllness', print_order: isNewOtherDoc ? 16 : 18 }]),
    ],
    opt_doctor: [
        { is_checked: false, label: 'Full Report', value: 'FullReport', print_order: 0 },
        { is_checked: true, label: 'Complaints', value: 'Complaints', print_order: 1 },
        { is_checked: true, label: 'Ocular History', value: 'OcularHistory', print_order: 2 },
        { is_checked: true, label: 'Systemic Illess', value: 'SystemicIllness', print_order: 3 },
        { is_checked: true, label: 'Vitals', value: 'Vitals', print_order: 4 },
        { is_checked: true, label: 'Vision Assessment', value: 'VisionAssesment', print_order: 5 },
        { is_checked: false, label: 'Ocular Response Analyzer', value: 'OcularResponseAnalyzer', print_order: 6 },
        { is_checked: true, label: 'Gonioscopy', value: 'Gonioscopy', print_order: 7 },
        { is_checked: false, label: 'Auto Refractrometry', value: 'AutoRefract', print_order: 8 },
        { is_checked: false, label: 'Previous Glass Power', value: 'PGP', print_order: 9 },
        { is_checked: false, label: 'Subjective Refraction', value: 'SubjectiveRefraction', print_order: 10 },
        { is_checked: false, label: 'Retinoscopic Refraction', value: 'ASR', print_order: 11 },
        { is_checked: false, label: 'Retinoscopic Acceptance', value: 'RectinoscopicAcceptance', print_order: 12 },
        { is_checked: true, label: 'Intraocular Pressure', value: 'IOP', print_order: 13 },
        { is_checked: true, label: 'Anterior Segment', value: 'AnteriorSeg', print_order: 14 },
        { is_checked: true, label: 'Anterior Segment Image', value: 'AnteriorImg', print_order: 15 },
        { is_checked: true, label: 'Posterior Segment', value: 'PosteriorSeg', print_order: 16 },
        { is_checked: false, label: 'Fundus', value: 'Fundus', print_order: 17 },
        { is_checked: true, label: 'Other Investigation', value: 'OtherInvestigation', print_order: 18 },
        { is_checked: false, label: 'Keratometry', value: 'Keratometry', print_order: 19 },
        { is_checked: false, label: 'IOL Master', value: 'IOLMaster', print_order: 20 },
        { is_checked: true, label: 'Diagnosis', value: 'Diagnosis', print_order: 21 },
        { is_checked: true, label: 'Medication', value: 'Medication', print_order: 22 },
        { is_checked: true, label: 'Glass Prescription', value: 'GlassPrescription', print_order: 23 },
        { is_checked: true, label: 'Review Plan', value: 'ReviewPlan', print_order: 24 },
        { is_checked: true, label: 'Treatment Plan', value: 'TreatmentPlan', print_order: 25 },
        { is_checked: true, label: 'Counselling', value: 'Conselling', print_order: 26 },
        { is_checked: true, label: 'Investigation', value: 'Investigation', print_order: 27 },
        { is_checked: false, label: 'Notes', value: 'Notes', print_order: 28 },
        { is_checked: false, label: 'Optometrist Notes', value: 'OptometryNotes', print_order: 29 },
        { is_checked: false, label: 'OCT Findings', value: 'OCTFindings', print_order: 30 },
        { is_checked: false, label: 'Schirmer Test', value: 'SchirmerTest', print_order: 31 },
    ],
}
if (JSON.parse(localGetItem('loggedInUserInfo'))?.new_doctor_notes_template === true) {
    let order = 0;
    DOC_PRINT_DEFAULT["opt_doctor"] = DOC_PRINT_DEFAULT?.opt_doctor?.reduce((acc, item) => {
        if (item.value === "RectinoscopicAcceptance") return acc; // skip
        acc.push({ ...item, print_order: order++ }); // add item and assign new print_order
        return acc;
    }, []);
    DOC_PRINT_DEFAULT?.opt_doctor?.push(
        { is_checked: false, label: 'Smile', value: 'Smile', print_order: DOC_PRINT_DEFAULT?.opt_doctor?.length },
        { is_checked: false, label: 'Presbyond', value: 'Presbyond', print_order: DOC_PRINT_DEFAULT?.opt_doctor?.length + 1 }
    )
}

export const FO_DOC_PRINT_DEFAULT = [
        { is_checked: true, label: 'All', value: 'All' },
        { is_checked: true, label: 'Vitals', value: 'Vitals' },
        { is_checked: true, label: 'Nurse Assessment', value: 'Nurse Assessment' },
        { is_checked: true, label: 'Doctor Notes', value: 'Doctor Notes' },
        { is_checked: true, label: 'Nurse Notes', value: 'Nurse Notes' },
        { is_checked: true, label: 'IV/IM Track', value: 'IV/IM Track' },
        { is_checked: true, label: 'Drug Chart', value: 'Drug Chart' },
        { is_checked: true, label: 'Pain Chart', value: 'Pain Chart' },
        { is_checked: true, label: 'Nutritional Chart', value: 'Nutrition Chart' },
        { is_checked: true, label: 'Input Output Chart', value: 'InputOutput Chart' },
        { is_checked: true, label: 'History', value: 'History' },
        { is_checked: true, label: 'Surgery Notes', value: 'Surgery Notes' },
    ]

export const Card_Layout_Default_JSON = [
    { id: 1, field_name: 'barcode', label: 'Barcode', with_label: "Patient Name : XX XXXXXXXXXXX", without_label: 'XX XXXXXXXXXXX', is_active: true, is_default: false },
    { id: 2, field_name: 'patient_name', label: 'Patient Name', with_label: "Patient Name : XX XXXXXXXXXXX", without_label: 'XX XXXXXXXXXXX', is_active: true, is_default: false },
    { id: 3, field_name: 'uhid', label: 'UHID', with_label: "UHID : XXXXX123465", without_label: 'XXXXX123465 ', is_active: true, is_default: false },
    { id: 4, field_name: 'age_gender', label: 'Age/Gender', with_label: 'Age / Gender : XX X / XXXXX', without_label: 'XX X / XXXXX', is_active: true, is_default: false },
    { id: 5, field_name: 'mobile_no', label: 'Mobile no', with_label: 'Mobile No : 1234567890', without_label: '1234567890', is_active: true, is_default: false },
    { id: 6, field_name: 'address_line_1', label: 'Address 1', with_label: 'Address 1 : YY/YY YYYYYYYY YYYYY', without_label: 'YY/YY YYYYYYYY YYYYY', is_active: true, is_default: false },
    { id: 7, field_name: 'city', label: 'City', with_label: 'City : ZZZZZZZZZZ', without_label: 'ZZZZZZZZZZ', is_active: true, is_default: false },
    { id: 8, field_name: 'dob', label: 'DOB', with_label: 'DOB : DD-MM-YYYY', without_label: 'DD-MM-YYYY', is_active: true, is_default: false },
    { id: 9, field_name: 'dob_gender', label: 'DOB/Gender', with_label: 'DOB / Gender : DD-MM-YYYY / XXXXX', without_label: 'DD-MM-YYYY / XXXXX', is_active: true, is_default: false },
    { id: 10, field_name: 'father_husband_name', label: 'Father/Spouse Name', with_label: 'Father/Spouse Name : XX XXXXXXXXXXX', without_label: 'XX XXXXXXXXXXX', is_active: true, is_default: false },
    { id: 11, field_name: 'address_line_2', label: 'Address 2', with_label: 'Address 2 : YY/YY YYYYYYYY YYYYY', without_label: 'YY/YY YYYYYYYY YYYYY', is_active: true, is_default: false },
    { id: 12, field_name: 'emergency_contact_mobile', label: 'Emergency Mobile No', with_label: 'Emergency No : 1234567890', without_label: '1234567890', is_active: true, is_default: false },
]

export const Label_Layout_Default_JSON = [
    { id: 1, field_name: 'barcode', label: 'Barcode', print_label: 'Barcode', is_active: false, is_default: false },
    { id: 2, field_name: 'ip_admission_id', label: 'IP Admission Id', print_label: 'IP Adm Id', is_active: true, is_default: false },
    { id: 3, field_name: 'admission_date', label: 'Date Of Admission', print_label: 'DOA', is_active: true, is_default: false },
    { id: 4, field_name: 'patient_name', label: 'Patient Name', print_label: 'PT Name', is_active: true, is_default: false },
    { id: 5, field_name: 'age_gender', label: 'Age/Gender', print_label: 'Age/Gender', is_active: false, is_default: false },
    { id: 6, field_name: 'mobile_no', label: 'Mobile no', print_label: 'Mob no.', is_active: false, is_default: false },
    { id: 7, field_name: 'address_line_1', label: 'Address 1', print_label: 'Address 1', is_active: false, is_default: false },
    { id: 8, field_name: 'dob', label: 'DOB', print_label: 'DOB', is_active: false, is_default: false },
    { id: 9, field_name: 'city', label: 'City', print_label: 'City', is_active: false, is_default: false },
    { id: 10, field_name: 'uhid', label: 'UHID', print_label: 'UHID', is_active: true, is_default: false },
    { id: 11, field_name: 'dob_gender', label: 'DOB/Gender', print_label: 'DOB/Gender', is_active: false, is_default: false },
    { id: 12, field_name: 'bed_room_ward', label: 'Bed/Room/Ward', print_label: 'B/R/W', is_active: true, is_default: false },
    { id: 13, field_name: 'consultant', label: 'Consultant', print_label: 'Consultant', is_active: false, is_default: false },
];

export const Attendercard_Layout_Default_JSON = [
    { id: 1, field_name: 'barcode', label: 'Barcode', print_label: 'Barcode', is_active: false, is_default: false },
    { id: 2, field_name: 'attender_name', label: 'Attender Name', print_label: 'Att. Name', is_active: true, is_default: true },
    { id: 3, field_name: 'attender_mobile_no', label: 'Mobile No', print_label: 'Mob No.', is_active: false, is_default: false },
    { id: 4, field_name: 'relationship', label: 'Relation', print_label: 'Relation', is_active: false, is_default: false },
    { id: 5, field_name: 'patient_name', label: 'Patient Name', print_label: 'Pt. Name', is_active: true, is_default: true, include_age_gender: true },
    { id: 6, field_name: 'uhid', label: 'UHID', print_label: 'UHID', is_active: false, is_default: false },
    { id: 7, field_name: 'ip_id', label: 'IP ID', print_label: 'IP ID', is_active: true, is_default: true },
    { id: 8, field_name: 'age_gender', label: 'Age/Gender', print_label: 'Age/Gender', is_active: false, is_default: false },
    { id: 9, field_name: 'bed_room_ward', label: 'Bed/Room/Ward', print_label: 'B/R/W', is_active: false, is_default: false },
];

export const Asset_Layout_Default_JSON = [
    { id: 1, field_name: 'barcode', label: 'Barcode', print_label: 'Barcode', is_active: true, is_default: true },
    { id: 2, field_name: 'asset_id', label: ' Asset ID ', print_label: 'Asset ID', is_active: true, is_default: true },
    { id: 3, field_name: 'asset_barcode_no', label: 'Barcode No', print_label: 'Barcode No', is_active: true, is_default: true },
    { id: 4, field_name: 'asset_name', label: 'Asset Name', print_label: 'Asset Name', is_active: true, is_default: true },
    { id: 5, field_name: 'asset_type', label: 'Asset Type', print_label: 'Asset Type', is_active: true, is_default: true },
    { id: 6, field_name: 'category', label: 'Category', print_label: 'Category', is_active: false, is_default: false },
    { id: 7, field_name: 'sub_category', label: 'Sub category', print_label: 'Sub category', is_active: false, is_default: false },
    { id: 8, field_name: 'spot_area', label: 'Spot/Area', print_label: 'Spot/Area', is_active: false, is_default: false },
];


export const OP_IP_CODE_LENGTH = 6
export const appointment_Status_opt = [
    { label: "Arrived", is_checked: true, is_default: true },
    { label: "With Nurse", is_checked: true, is_default: false },
    { label: "With OPTOS", is_checked: true, is_default: false },
    { label: "With Optometry", is_checked: true, is_default: false },
    { label: "Optometry Completed", is_checked: false, is_default: false },
    { label: "With Doctor", is_checked: true, is_default: true },
    { label: "In Opticals", is_checked: false, is_default: false },
    { label: "Opticals Completed", is_checked: false, is_default: false },
    { label: "With Counsellor", is_checked: false, is_default: false },
    { label: "Scan/Surgery", is_checked: true, is_default: false },
    { label: "Completed", is_checked: true, is_default: true },
]
export const Cancel_appointment_Status_opt = [
    { label: "Arrived", is_checked: true, is_default: true },
    { label: "With Nurse", is_checked: false, is_default: false },
    { label: "With OPTOS", is_checked: false, is_default: false },
    { label: "With Optometry", is_checked: false, is_default: false },
    { label: "Optometry Completed", is_checked: false, is_default: false },
    { label: "With Doctor", is_checked: false, is_default: false },
    { label: "In Opticals", is_checked: false, is_default: false },
    { label: "Opticals Completed", is_checked: false, is_default: false },
    { label: "With Counsellor", is_checked: false, is_default: false },
    { label: "Scan/Surgery", is_checked: false, is_default: false },
]

export const appointment_Status_other = [
    { value: "Arrived", is_checked: true, is_default: true },
    { value: "With Nurse", is_checked: true, is_default: false },
    { value: "With Doctor", is_checked: true, is_default: true },
    { value: "With Counsellor", is_checked: true, is_default: false },
    { value: "Completed", is_checked: true, is_default: true },
]

export const Header_Filter_Fields = [
    { value: "address", is_checked: true, is_default: true, label: "Search by Address" },
    { value: "father husband name", is_checked: true, is_default: true, label: "Search by Father/Spouse" },
    { value: "dob", is_checked: false, is_default: false, label: "Search by DOB" },
    { value: "mother name", is_checked: true, is_default: true, label: "Search by Mother Name" },
    { value: "uhid", is_checked: false, is_default: false, label: "Search by UHID" },
    { value: "op_ip_number", is_checked: true, is_default: false, label: "Search by OP/IP Number" },
]

export const Histopatholog_Header_Filter_Fields = [
    { value: "address", is_checked: true, is_default: true, label: "Search by Address" },
    { value: "father husband name", is_checked: true, is_default: true, label: "Search by Father/Spouse" },
    { value: "specimen_id", is_checked: true, is_default: false, label: "Search by Specimen ID" },
    { value: "sequence_no", is_checked: true, is_default: false, label: "Search by Overall Sequence No" },
]

export const Code_Length = 6

export const Ip_Doc_PRINT_DEFAULT = [
    { is_checked: true, label: 'Full Report', value: 'FullReport' },
    { is_checked: true, label: 'Symptoms', value: 'Symptoms' },
    { is_checked: true, label: 'Examination', value: 'Examination' },
    // { is_checked: true, label: 'Diagnosis', value: 'Diagnosis' },
    { is_checked: true, label: 'Provisional Diagnosis', value: 'Provisional Diagnosis' },
    { is_checked: true, label: 'ICD 10 Code Diagnosis', value: 'ICD Diagnosis' },
    { is_checked: true, label: 'Counselling', value: 'Counselling' },
    { is_checked: true, label: 'Discharge Notes', value: 'Discharge Notes' },
    { is_checked: true, label: 'Family Counselling', value: 'Family Counselling' },
    { is_checked: true, label: 'Medication & Instructions', value: 'Medication and Instruction' },
    { is_checked: true, label: 'Progressive Notes', value: 'Write Notes' },
]

export const IOL_Master_Data = [
    { label: 'K1', le_eye: '', re_eye: '' },
    { label: 'K2', le_eye: '', re_eye: '' },
    { label: 'AL', le_eye: '', re_eye: '' },
    { label: 'AQD', le_eye: '', re_eye: '' },
    { label: 'CCT', le_eye: '', re_eye: '' },
    { label: 'WTW', le_eye: '', re_eye: '' },
    { label: 'IOL', le_eye: '', re_eye: '' },
]

export const OPT_DOCTOR_STATUS = [
    { label: 'All', value: 'All' },
    { label: 'Booked', value: 'Booked' },
    { label: 'Arrived', value: 'Arrived' },
    { label: 'With Nurse', value: 'With Nurse' },
    { label: 'With Optometry', value: 'With Optometry' },
    { label: 'Optometry Completed', value: 'Optometry Completed' },
    { label: 'With Doctor', value: 'With Doctor' },
    { label: 'With Counsellor', value: 'With Counsellor' },
    { label: 'Scan/Surgery', value: 'Scan/Surgery' },
]

export const DOCTOR_STATUS = [
    { label: 'All', value: 'All' },
    { label: 'Booked', value: 'Booked' },
    { label: 'Arrived', value: 'Arrived' },
    { label: 'With Nurse', value: 'With Nurse' },
    { label: 'With Doctor', value: 'With Doctor' },
    { label: 'With Counsellor', value: 'With Counsellor' },
]

export const NEW_DOC_NOTES_LIST = [
    { label: 'Go Top', image: ImagePaths.upArrow.default, value: 'Go Top' },
    { label: 'Refraction', image: ImagePaths.RefractionNew.default, value: 'Refraction' },
    { label: 'Ocular Resp. Ana.', image: ImagePaths.OcularResponseNew.default, value: 'Ocular Response Analyzer' },
    { label: 'Smile', image: ImagePaths.smileIcon.default, value: 'Smile' },
    { label: 'Presbyond', image: ImagePaths.prebyondIcon.default, value: 'Presbyond' },
    { label: 'Glass Presp.', image: ImagePaths.GlassPrespNew.default, value: 'Glass Presp.' },
    { label: 'Anterior Seg.', image: ImagePaths.PostSegmentNew.default, value: 'Anterior Segment' },
    { label: 'Posterior Seg.', image: ImagePaths.AnteriorSegmentNew.default, value: 'Posterior Segment' },
    { label: 'Diagnosis', image: ImagePaths.DiagnosisNew.default, value: 'Diagnosis' },
    { label: 'Medication', image: ImagePaths.MedicationNew.default, value: 'Medication' },
    // { label: 'Investigations', image: ImagePaths.InvestigationNew.default, value: 'Investigations' },
    { label: 'Keratometry', image: ImagePaths.KetometryNew.default, value: 'Ketomentry' },
    { label: 'Gonioscopy', image: ImagePaths.GonioscopyNew.default, value: 'Gonioscophy' },
    { label: 'Other Invest.', image: ImagePaths.OtherInvestigationNew.default, value: 'Other Investigation' },
    { label: 'IOL Master', image: ImagePaths.IOLMasterNew.default, value: 'IOL Master' },
    { label: 'Treatment Plan', image: ImagePaths.TreatmentPlanNew.default, value: 'Treatment Plan' },
    { label: 'Review/Investigation', image: ImagePaths.ReviewPlanNew.default, value: 'Review/Investigation' },
    { label: 'Counsellor', image: ImagePaths.CounsellorNew.default, value: 'Counsellor' },
]

export const NEW_DOC_NOTES_FOR_COLLAB_SUMMARY = [
    { field_name: 'complaints', label: 'Complaints', is_active: true },
    { field_name: 'vision_assesment', label: 'Vision Assesment', is_active: true },
    { field_name: 'vitals', label: 'Vitals', is_active: true },
    { field_name: 'ocular_history', label: 'Ocular History', is_active: true },
    { field_name: 'systemic_illness', label: 'Systemic Illness', is_active: true },
    { field_name: 'previous_glass_power', label: 'Previous Glass Power', is_active: true },
    { field_name: 'Patient Category', label: 'Patient Category', is_active: true },
    { field_name: 'retinoscopic_refraction', label: 'Retinoscopic Refraction', is_active: true },
    { field_name: 'auto_refractory', label: 'Auto Refractory', is_active: true },
    { field_name: 'subjective_refraction', label: 'Subjective Refraction', is_active: true },
    { field_name: 'intraocular_pressure', label: 'Intraocular Pressure', is_active: true },
    { field_name: 'ocular_response_analyzer', label: 'Ocular Response Analyzer', is_active: true },
    { field_name: 'optometry_notes', label: 'Optometrist Notes', is_active: true },
    { field_name: "smile", label: 'Smile', value: 'Smile', is_active: true },
    { field_name: "presyound", label: 'Presbyond', value: 'Presbyond', is_active: true },
    { field_name: 'glass_prescription', label: 'Glass Prescription', is_active: true },
    { field_name: 'anterior_segment', label: 'Anterior Segment', is_active: true },
    { field_name: 'anterior_segment_diagram', label: 'Anterior Segment Diagram', is_active: true },
    { field_name: 'posterior_segment', label: 'Posterior Segment', is_active: true },
    { field_name: 'fundus', label: 'Fundus', is_active: true },
    { field_name: 'diagnosis', label: 'Diagnosis', is_active: true },
    { field_name: 'prescription', label: 'Prescription', is_active: true },
    { field_name: 'keratomentry', label: 'Keratomentry', is_active: true },
    { field_name: 'gonioscopy', label: 'Gonioscopy', is_active: true },
    { field_name: 'other_investigation', label: 'Other Investigation', is_active: true },
    { field_name: 'IOLMaster', label: 'IOLMaster', is_active: true },
    { field_name: 'treatment_plan', label: 'Treatment Plan', is_active: true },
    { field_name: 'notes', label: 'Notes', is_active: true },
    { field_name: 'review_plan', label: 'Review Plan', is_active: true },
    { field_name: 'investigations', label: 'Investigations', is_active: true }
]


export const NEW_DOC_EYE_TYPE = [
    { label: 'Right Eye (OD)', value: 1 },
    { label: 'Left Eye (OS)', value: 2 },
    { label: 'Both (OU)', value: 3 },
]

export const NEW_DOC_EYE_TYPE_NEW = [
    { label: 'Right Eye (OD)', value: 'Right Eye (OD)' },
    { label: 'Left Eye (OS)', value: 'Left Eye (OS)' },
    { label: 'Both (OU)', value: 'Both (OU)' },
]

export const NEW_DOC_DURATION_LIST = [
    { label: 'Days', value: '1' },
    { label: 'Weeks', value: '2' },
    { label: 'Months', value: '3' },
    { label: 'Years', value: '4' },
]

export const BILL_LAYOUT_LIST = [
    {
        "id": 1,
        "module": "IP",
        "layout_detail": [
            {
                "label": "Service Package",
                "order": 1,
                "value": "package",
                "is_active": true
            },
            {
                "label": "Service Description",
                "order": 2,
                "value": "description",
                "is_active": true
            },
            {
                "label": "Service Code",
                "order": 3,
                "value": "code",
                "is_active": false
            },
            {
                "label": "Assorted Package",
                "order": 4,
                "value": "assorted pack",
                "is_active": false
            }
        ],
        "modified_by": "",
        "modified_date": ""
    },
    {
        "id": 2,
        "module": "OP",
        "layout_detail": [
            {
                "label": "Service Description",
                "order": 1,
                "value": "description",
                "is_active": true
            },
            {
                "label": "Service Template",
                "order": 2,
                "value": "template",
                "is_active": true
            },
            {
                "label": "Service Code",
                "order": 3,
                "value": "code",
                "is_active": false
            },
            {
                "label": "Corporate Services",
                "order": 4,
                "value": "corporate",
                "is_active": false
            }
        ],
        "modified_by": "",
        "modified_date": ""
    }
]

export const UMA_FRAME_TYPE = [
    { value: 'FULL FRAME', label: 'FULL FRAME' },
    { value: 'SEMI RIMLESS FRAME', label: 'SEMI RIMLESS FRAME' },
    { value: 'RIMLESS FRAME', label: 'RIMLESS FRAME' }
]

export const UMA_IOL_MASTER_LIST = [
    { label: 'K1', le_eye: '', re_eye: '' },
    { label: 'K2', le_eye: '', re_eye: '' },
    { label: 'AL', le_eye: '', re_eye: '' },
    { label: 'AQD', le_eye: '', re_eye: '' },
    { label: 'CCT', le_eye: '', re_eye: '' },
    { label: 'WTW', le_eye: '', re_eye: '' },
    { label: 'IOL', le_eye: '', re_eye: '' },
    { label: 'Average', le_eye: '', re_eye: '' },
    { label: 'Cylindrical', le_eye: '', re_eye: '' },
    { label: 'A Constant 1.80', le_eye: '', re_eye: '' },
    { label: 'A Constant 1.84', le_eye: '', re_eye: '' },
    { label: 'A Constant 1.87', le_eye: '', re_eye: '' },
    { label: 'Toric', le_eye: '', re_eye: '' },
]

export const COMMON_STYLE = {
    HEIGHT: '4.5dvh',
    PADDING: '0rem',
    MAX_HEIGHT: '20dvh',
    NO_RECORDS: 'No Records To Be Shown',
    CHAR_LIMIT_DESP: 1000,
    CHAR_LIMIT_COMMENTS: 250,
    DATE_LIMIT: 31
}

export const UMA_DOCTOR_NOTES_COMPONENT = [
    // 'Complaints & Patient Category',
    'Complaints & VisionAssessment',
    'vitals',
    'OcularHistory & Illness',
    // 'PrevGlassPower & VisionAssessment',
    'PrevGlassPower & Patient Category',
    'RetinoRefraction & AutoRefractory',
    'SubRefraction',
    'IntracularPressure & OcularResponse',
    'OptometryNotes',
    'Smile & Presbyond',
    'GlassPrescription',
    'AnteriorSegment & AnteriorDiagram',
    'PosteriorSegment & Fundus',
    'Diagnosis',
    'Medication',
    'Keratometry & Goniosopy',
    'OtherInvestigation & IolMaster',
    'TreatmentPlan & Notes',
    'ReviewPlan & Investigation',
]

export const UMA_USAGE_LIST = [
    { value: "ES", label: "Empty Stomach" },
    { value: "BF", label: "Before Food" },
    { value: "WF", label: "With Food" },
    { value: "AF", label: "After Food" },
    { value: "EA", label: "External Application" },
    { value: "IA", label: "Internal Application" },
]

export const NEW_DOC_DURATION_LIST_OTHER = [
    { label: 'Days', value: 'Days' },
    { label: 'Weeks', value: 'Weeks' },
    { label: 'Months', value: 'Months' },
    { label: 'Years', value: 'Years' },
]

export const USAGE_TYPE = [
    { value: "ES", label: "Empty Stomach" },
    { value: "BF", label: "Before Food" },
    { value: "WF", label: "With Food" },
    { value: "AF", label: "After Food" },
    { value: "EA", label: "External Application" },
    { value: "IA", label: "Internal Application" },
]

export const Eye_Type = [
    { value: "RE", label: "RE", show_label: 'Right Eye (OD)' },
    { value: "LE", label: "LE", show_label: 'Left Eye (OS)' },
    { value: "BE", label: "BE", show_label: 'Both (OU)' }
]

export const DROP_FREQ = [
    { value: "1", label: "1 time a day" },
    { value: "2", label: "2 times a day" },
    { value: "3", label: "3 times a day" },
    { value: "4", label: "4 times a day" },
    { value: "5", label: "5 times a day" },
    { value: "6", label: "6 times a day" },
    { value: "10", label: "10 times a day" },
    { value: "12", label: "12 times a day" }
];

export const OPT_MED_TAP_DURATION = [
    { value: "Day(s)", label: "Day(s)" },
    { value: "Week(s)", label: "Week(s)" },
    { value: "Month(s)", label: "Month(s)" },
];

export const OPT_MED_DURATION = [
    { value: "Days", label: "Days" },
    { value: "Weeks", label: "Weeks" },
    { value: "Months", label: "Months" },
    { value: "Until_the_Next_Visit", label: "Until the Next Visit" },
    { value: "Long_Term", label: "Long Term" }
];

export const UMA_RECOMMENDED_EYE_WEAR = [
    { label: 'Full Time Wear', value: 'Full Time Wear', default: true },
    { label: 'Distance Only', value: 'Distance Only', default: true },
    { label: 'Near Only', value: 'Near Only', default: true },
    { label: 'Computer Only', value: 'Computer Only', default: true },
    { label: 'Contact Lens', value: 'Contact Lens', default: true }
]

export const UMA_LENS_TYPE = [
    { label: 'Single Vision', value: 'Single Vision', default: true },
    { label: 'Kryptok', value: 'Kryptok', default: true },
    { label: 'Progressive', value: 'Progressive', default: true },
    { label: 'D-Bifocal', value: 'D-Bifocal', default: true },
    { label: 'Executive', value: 'Executive', default: true },
    { label: 'MyoCare', value: 'MyoCare', default: true }
]

export const UMA_LENS_MATERIAL = [
    { label: 'Plastic', value: 'Plastic', default: true },
    { label: 'Poly Cabonate', value: 'Poly Cabonate', default: true },
    { label: 'High Index', value: 'High Index', default: true },
    { label: 'Glass', value: 'Glass', default: true },
    { label: 'Polarized', value: 'Polarized', default: true }
]

export const UMA_LENS_ENHANCEMENT = [
    { label: 'Anti Reflection coating', value: 'Anti Reflection coating', default: true },
    { label: 'Photo-chromatic Lenses', value: 'Photo-chromatic Lenses', default: true },
    { label: 'UV Protection', value: 'UV Protection', default: true },
    { label: 'Blue cut + UV Protection', value: 'Blue cut + UV Protection', default: true },
    { label: 'Tint', value: 'Tint', default: true }
]

export const UMA_LENS = [
    { label: 'Disposable Soft', value: 'Disposable Soft', default: false },
    { label: 'Daily', value: 'Daily', default: false },
    { label: 'Extended Wear', value: 'Extended Wear', default: false },
    { label: 'Spherical', value: 'Spherical', default: false },
    { label: 'Toric', value: 'Toric', default: false },
    { label: 'Monovision', value: 'Monovision', default: false },
    { label: 'Multifocal / Bifocal', value: 'Multifocal / Bifocal', default: false },
    { label: 'Conventional', value: 'Conventional', default: false },
    { label: 'Rigid Gas Permeable', value: 'Rigid Gas Permeable', default: false },
    { label: 'Hard', value: 'Hard', default: false },
]
export const OTHER_INVESTIGATION_CONFIG_DATA = {
    "WFDT": { "is_checked": true },
    "EOM": { "is_checked": true },
    "Color Vision": { "is_checked": true },
    "Confrontation": { "is_checked": true },
    "Pupil": { "is_checked": true },
    "Pachymetry": { "is_checked": true },
    "Schirmer's Test": { "is_checked": true },
    "Contrast Sensitivity": { "is_checked": true },
    "Syringe": { "is_checked": true },
    "Additional Details": { "is_checked": true },
    "Duct": { "is_checked": true }
}

export const OUR_MODULES_LIST = [
    {
        'module_name': "Front Office",
        'value': "Front Office"
    },
    {
        'module_name': "Pharmacy",
        'value': "Pharmacy"
    },
    {
        'module_name': "Laboratory",
        'value': "LAB"
    },
    {
        'module_name': "Radiology",
        'value': "Radiology"
    },
]

export const creditCorpTypes = new Set(["Corprate credit", "Corporate credit"]);

export const labelMap = {
    is_fasting: "Fasting",
    is_30min: "1/2 Hour",
    is_1hr: "1 Hour",
    is_1_5hr: "1 1/2 Hour",
    is_2hr: "2 Hour",
    is_2_5hr: "2 1/2 Hour",
    is_3hr: "3 Hour"
};

export const appointmentSet = new Set([
    'Arrived',
    'With Nurse',
    'With OPTOS',
    'Optometry',
    'Optometry Completed',
    'With Doctor',
    'In Opticals',
    'Opticals Completed',
    'With Counsellor',
    'Scan/Surgery',
]);

export const sliceSet = (fromIndex, toIndex = 11) => {
    const slicedArray = [...appointmentSet].slice(fromIndex, toIndex);
    return new Set(slicedArray);
};

export const showDilationList = new Set(['Arrived', 'Booked', 'Ip Appointment', 'With Nurse', 'With OPTOS', "Completed", "Cancelled"]);

export const painLevelTxt = {
    "(0-1)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "No Pain" },
    "(1-3)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "Mild Pain" },
    "(3-4)": { image: ImagePaths.moderateSmile.default, color: "#FFCD05", status: "Moderate" },
    "(5-7)": { image: ImagePaths.severeSmile.default, color: "#F8981D", status: "Severe" },
    "(7-9)": { image: ImagePaths.verySevereSmile.default, color: "#F26A22", status: "Very Severe" },
    "(9-10)": { image: ImagePaths.worstPainsmile.default, color: "#DA1A32", status: "Worst Pain Possible" },
};

export const painScaleImgList = [
    { value: "(0-1)", image: ImagePaths.noPain.default },
    { value: "(1-3)", image: ImagePaths.mildPain.default },
    { value: "(3-4)", image: ImagePaths.moderatePain.default },
    { value: "(5-7)", image: ImagePaths.severePain.default },
    { value: "(7-9)", image: ImagePaths.verySevere.default },
    { value: "(9-10)", image: ImagePaths.worstPain.default },
];

export const IP_DOC_NOTES_LAYOUT = [
    { field_name: 'symptoms', system_name: 'Symptoms', custom_name: 'Symptoms', is_active: true, is_new: false },
    { field_name: 'patient_category', system_name: 'Patient Category', custom_name: 'Patient Category', is_active: true, is_new: false },
    { field_name: 'allergies', system_name: 'Allergies', custom_name: 'Allergies', is_active: true, is_new: false },
    { field_name: 'examination', system_name: 'Examination', custom_name: 'Examination', is_active: true, is_new: false },
    { field_name: 'diagnosis', system_name: 'Diagnosis', custom_name: 'Diagnosis', is_active: true, is_new: false },
    { field_name: 'provisional_diagnosis', system_name: 'Provisional Diagnosis', custom_name: 'Provisional Diagnosis', is_active: true, is_new: false },
    { field_name: 'plan', system_name: 'Plan', custom_name: 'Plan', is_active: true, is_new: false },
    { field_name: 'general_advice', system_name: 'General Advice', custom_name: 'General Advice', is_active: true, is_new: false },
    { field_name: 'review_plan', system_name: 'Review Plan', custom_name: 'Review Plan', is_active: true, is_new: false },
    { field_name: 'Complaints', system_name: 'Complaints', custom_name: 'Complaints', is_active: true, is_new: false },
    { field_name: 'final_diagnosis', system_name: 'Final Diagnosis', custom_name: 'Final Diagnosis', is_active: false, is_new: false },
    { field_name: 'pain_scale', system_name: 'Pain Scale', custom_name: 'Pain Scale', is_active: false, is_new: false },
];

export const oxygen_source_list = [
    { label: 'Atmosphere Air', value: 'Atmosphere Air' },
    { label: 'O2 (With Oxygen)', value: 'O2 (With Oxygen)' },
]
export const TXN_MSG_MAX = 'Minimum Reference Number should be 4 digit'
export const TXN_MSG_MAX_LEN = 4

